"use strict";
import * as Tone from "tone";
import {rTComment} from "../rikis"
/**
Il file attiva le variabili globali  e gli strumenti
*/

/** IMPOSTAZIONE TEXTURE DATI OGGETTI */
/** IMPOSTAZIONE TEXTURE DATI OGGETTI */


/*
indirizzo al texdata che useremo come luogo dove mettere audio e video proprietà
window.texData=texture che passa i parametri agli shader!!
//js.array.slice fa una shallow copy swll'array: significa che recupera la referenza all'array, non copia i valori!!
texAddress[0]: video active
texAddress[1]: video data (valori rms!)
texAddress[2]: audio active
texAddress[3]: audio data (valori rms!)
*/
window.texData = [];

/**Commenti si o no! */
//var rTComment=0;

/** IMPOSTAZIONE TEXTURE DATI OGGETTI */
/** IMPOSTAZIONE TEXTURE DATI OGGETTI */



/**La funzione ritorna la posizione del tempo posizionata per beats. EG. se il beat è .2 adesso 1.1234 diventa 1.0,  */
var scatterFloorTime = function(time, beatunit = 1, beat = .2) {
	let t = beat * beatunit;
	return Math.floor((time / t)) * t;
}
/**La funzione ritorna la posizione del tempo posizionata per beats. EG. se il beat è .2 adesso 1.1234 diventa 1.0,  */
var scatterCeilTime = function(time, beatunit = 1, beat = .2) {
	let t = beat * beatunit;
	return Math.ceil((time / t)) * t;
}

/**prende l'input in beats e ne ritorna l'equivalente temporale in secondi */
var beatsToTime = function(input, beat) {
	return input * beat;
}


/**la durata del singolo beat in secondi! */
var rBeat = .6;

var destination_rms = new Tone.Meter();

destination_rms.connect(Tone.getDestination());


/**SEQUENCER */
/**SEQUENCER */
/** 
insieme di note e funzioni che faranno funzionare lo strumento sopra! sarà attaccato all'isola invece delle note
L'idea è che adesso invece di attaccare singole note alle isole ci attacchiamo intere sequenze con strumento annesso
*/
var RSequencer = {
	//i dati del sequencer
	data: {
		//per far funzionar sempre il getter sotto
		notes: {
			length: -1
		}
	},
	/**Ritorna il numero di note della sequenza */
	get numNotes() {
		return this.data.notes.length;
	},
	/**
	inizializzazione, inzializziamo i dati al volo per permettere la differenziazione degli oggetti
	
	se mode è "limit" allora non ci sono limitazioni agli strumenti che possono suonare contemporaneamente
	*/
	init: function(isle, mode = "limit") {

		//ritorna true se tutto ok!
		let ret = false;

		//GLOBAL VALUES
		//GLOBAL VALUES
		let pool = isle.global.instrumentPool; //pool strumenti
		let poolId = pool.id; //l'id del pool, che corrisponde alla posizione in seno all'array
		let startNote = isle.global.startNote;
		let accordPosition = isle.global.accordPosition;
		let accord = isle.global.accord;
		//GLOBAL VALUES
		//GLOBAL VALUES

		//ISLE VALUES
		//ISLE VALUES
		let normalizedNumberOfElements = isle.isle.normalizedNumberOfElements;
		let colorVal = isle.isle.colorVal;
		let color = isle.normColor; //rgbd
		let bd = isle.normBrightDark;  //bright dark
		//ISLE VALUES
		//ISLE VALUES

		//GAIN FOR THE NOTE SEQUENCE
		//GAIN FOR THE NOTE SEQUENCE

		let gain = Number;
		if (isle.id == 1) {
			gain = 1;
		} else {
			gain = normalizedNumberOfElements;
		}
		//GAIN FOR THE NOTE SEQUENCE
		//GAIN FOR THE NOTE SEQUENCE

		//INSTRUMENT AND SEQUENCE SELECTION
		//INSTRUMENT AND SEQUENCE SELECTION

		let instrument_position = -1;
		let seq = [];
		let simul_pool = {};

		if (isle.id == 1) {
			//Instrument pool
			instrument_position = instPools.selectInstrumentPosition(poolId, "single");

			//quanti di questi possono suonare contemporaneamente
			//			simul_pool = simulPool.assign(1);
			(mode == "limit") ? simul_pool = simulPool.assign(1) : simul_pool = simulPool.assign(1000);

			//sequence
			seq = noteSequences.getSequences("single");

		} else if (normalizedNumberOfElements > .80) {

			//Instrument pool
			instrument_position = instPools.selectInstrumentPosition(poolId, "solo");

			//quanti di questi possono suonare contemporaneamente
			//			simul_pool = simulPool.assign(1);
			(mode == "limit") ? simul_pool = simulPool.assign(1) : simul_pool = simulPool.assign(1000);

			//sequence
			seq = noteSequences.getSequences("solo");

		} else if (normalizedNumberOfElements > .5) {

			//Instrument pool
			instrument_position = instPools.selectInstrumentPosition(poolId, "orch");

			//quanti di questi possono suonare contemporaneamente

			(mode == "limit") ? simul_pool = simulPool.assign(5) : simul_pool = simulPool.assign(1000);


			//sequence
			seq = noteSequences.getSequences("orch");

		} else { //DRUM

			//Instrument pool
			instrument_position = instPools.selectInstrumentPosition(poolId, "drum");

			//quanti di questi possono suonare contemporaneamente
			(mode == "limit") ? simul_pool = simulPool.assign(10) : simul_pool = simulPool.assign(1000);

			//sequence
			seq = noteSequences.getSequences("drum");

		}

		//qualcosa non è andato bene, torniamo false
		if (seq.length == 0 || instrument_position == -1) {
			if (rTComment) console.log('Sequenza NON inizializzata ', isle.id, seq, instrument_position);
			return false;
		}


		//DEBUGGGG
		//DEBUGGGG
		//		instrument_position = Math.floor(Math.random() * 8 + 14);
		//		instrument_position = 6;
		//DEBUGGGG
		//DEBUGGGG


		//FASE 1: selezione dello strumento (avrà tutte le carattteristiche: min e max nota etc..)
		let instrument = rInstruments.getInstrument(instrument_position);


		//INSTRUMENT AND SEQUENCE SELECTION
		//INSTRUMENT AND SEQUENCE SELECTION


		//FASE 2 - selezione delle note in base alle possibilità dello istrumento
		let start_note = instrument.lowest_note + Math.floor((1 - isle.normalizedNumberOfElements) * (instrument.highest_note - instrument.lowest_note));

		let repetitions = 0;
		let pause_inbetween = 0;
		let numero_note = 1;
		let max_notes = 20; //numero massimo di note nella sequenza


		//INSTRUMENT DATA
		//INSTRUMENT DATA
		/**
		Utilizzo dell'accordo:
		nel creare sequenze di note l'accordo scelto forza l'utilizzo delle note presenti!
		 */
		this.data = {
			//Lo strumento attribuito
			instrument: instrument, //lo strumento (riferimento all'array)
			/**Indica la posizione dello strumento in window.rStrumenti.Instruments. Da questa si ricava il tipo etc. */
			instrumentPosition: instrument_position,
			isleID: isle.id, //l'id dell'isola
			//posizione per l'audio 3D //INVERTIRAL X in Y za stereo navpicno!
			//			isle_position: [isle.ocenter[1], 0, 0],
			isle_position: isle.ocenter,
			texAudioAddressActive: isle.texAudioAddressActive,
			texAudioAddressData: isle.texAudioAddressData,
			playing: 0, //se sta suonando o meno
			start_time: 0, //quando comincia la sequenza
			start_note: start_note, //la nota d'inizio, posizione in seno all'array
			repetitions: repetitions, //quante volte ripeteremo la sequenza
			pause_inbetween: pause_inbetween, //il tempo fra una ripetizione e l'altra
			accordPosition: accordPosition, //la posizione dell'accordo che useremo per sequenziare le note

			simul_pool: simul_pool, //riferimento a quanti strumenti possono suonare contemporaneamente

			notes: [],

			/**Riprende i metodi di rStrumenti!!! */
			canPlay() {
				let rapp = this;
				//ALTERNATIVE
				//ALTERNATIVE
				return true;
				//ALTERNATIVE
				//ALTERNATIVE
				return rapp.simul_pool.canPlay();
			},
			increment_sounds() {
				let rapp = this;
				return rapp.simul_pool.increment();
			},
			decrement_sounds() {
				let rapp = this;
				return rapp.simul_pool.decrement();
			},
			/**legato all'output dello strumento che suona: attribuirà a questa funzione il suo metodo output 
			(in instrument->play) */
			output() {

			}
		};
		//INSTRUMENT DATA
		//INSTRUMENT DATA

		//NOTES
		//NOTES

		//		[//la sequenza di note: DA DETERMINARE ANCHE IN SEGUITO TRAMITE FUNZIONE GENERATIVA o di scelta SOTTO
		//			{
		//				note: 0, //il posto della nota in seno all'array (notevalues etc.: [start_note+note]
		//				duration: 1, //in secondi: calcolati all'atto della creazione trasformando l'input in beats!
		//				position: 0, //in secondi: calcolati all'atto della creazione quando la facciamo suonare!
		//				velocity: 1, //volume: 0->1
		//				pan: 0, //pan da -1->1, 0 in mezzo!
		//				portamento: 1,
		//				/** 	tipologia cambiamento (indicato dall'offset) da una nota alla corrispettiva della serie successiva:
		//	   0-immediato, 1-rampTo, 2-exponentialRampTO... */
		//				change_type: 2
		//			}
		//		]

		/**aggiungiamo le note al sequencer */
		ret = this.setNotes(seq[0], gain);
		if (rTComment) console.log(`SEQ INIT ${instrument.name} result: ${ret}`);
		return ret;

		//NOTES
		//NOTES

		//INSTRUMENT
		//INSTRUMENT

	},
	//
	/**
	inizio sequenza, imposta lo start time e fa partire. Si fa carico del rilascio dello strumento etc.
	
	nel caso canPlay sia false non vi saranno controlli per suoni simultanei
	 */
	play(canPlay = false) {
		let cp = true;
		if (canPlay) cp = this.data.canPlay();

		if (!this.data.playing && cp) {
			/** Impostiamo come playing lo strumento */
			/**Counter di strumenti contemporanei: se ritorna false vuol dire che ci sono troppi strumenti che suonano in contemporanea, usciamo senza suonare! */
			if (cp && !this.data.increment_sounds()) {
				this.data.playing = false;
				//DEBUGG
				//DEBUGG
				//				return;
				//DEBUGG
				//DEBUGG
			}
			//Se ok impostiamo che sta suonando, altrimenti no
			if (this.data.instrument.play(this.data)) {
				this.data.playing = true;
				if (rTComment) console.log(`PLAYYYYYY TRUE INNER TRUE isleid: ${this.data.isleID} cont.seq: `, this.data.simul_pool.situation);
			} else {
				this.data.playing = false;
				if (rTComment) console.log(`PLAYYYYYY TRUE INNER FALSE isleid: ${this.data.isleID} cont.seq: `, this.data.simul_pool.situation);
			};
		} else {
			this.data.playing = false;
			if (rTComment) console.log(`PLAYYYYYY FALSE isleid: ${this.data.isleID} cont.seq: `, this.data.simul_pool.situation);
		}
	},
	/**
	Utilizza la sequenza per creare le note; ritorna 
	
	Formato di input, array dati:
		[
			max: 100,
			counter: 0,
			notes: [
				nota
				durata
				posizione
				volume
				pan
				portamento
			]
		]
	 */


	/**
	gain: 0->1, va moltiplicato al volume della nota!
	 */
	setNotes(noteSequence, gain) {

		try {
			if (noteSequence.counter > noteSequence.max) {
				if (rTComment) console.log('sequenza non accettata!');
				return false;
			}

		} catch (e) {
			if (rTComment) console.log('che klinc', e);
			return false;
		}
		//abbiamo sforato il numero di sequenze utilizzabili, ritorniamo false

		//aumentiamo il numero di utilizzi della sequenza!
		noteSequence.counter++;

		let rapp = this;

		//inizializziamo l'array note
		rapp.data.notes = [];

		//accordPosition scelto
		let acc = Accordi[rapp.data.accordPosition];
		//lunghezza accordo
		let al = acc.length;

		//numero sequencer contemporanei impostato!
		let N = noteSequence.notes.length; //numero note presenti

		//++++++++++++++++++++
		//++++++++++++++++++++
		//		if (N > 20) {
		//			rapp.data.contemporarySequences = 1;
		//		} else if (N > 10) {
		//			rapp.data.contemporarySequences = 2;
		//		} else if (N > 5) {
		//			rapp.data.contemporarySequences = 4;
		//		} else if (N > 4) {
		//			rapp.data.contemporarySequences = 5;
		//		} else if (N > 3) {
		//			rapp.data.contemporarySequences = 6;
		//		} else if (N > 2) {
		//			rapp.data.contemporarySequences = 10;
		//		} else {
		//			rapp.data.contemporarySequences = 20;
		//		}

		if (rTComment) console.log(`SEQ SETNOTES ${rapp.data.instrument.name}, Contemporary sequences: ${rapp.data.contemporarySequences}, accordposition: ${rapp.data.accordPosition} nsequences: ${noteSequence.notes.length} use counter: ${noteSequence.counter}  max use: ${noteSequence.max}`);

		//++++++++++++++++++++
		//++++++++++++++++++++

		///Recuperata la tipologia strumento da window.rStrumenti
		let inst = rInstruments.getInstrument(rapp.data.instrumentPosition);
		let maxminnota = [inst.lowest_note, inst.highest_note];

		rapp.data.sequenceID = noteSequence.id;

		//aggiungiamo le note dall'array parametro
		noteSequence.notes.forEach(function(n, k) {

			let px = n[0] % al; //posizione della nota in seno all'accordo come modulo posizione/lunghezza accordo
			let py = Math.floor(n[0] / al); //ottava relativa

			let nota_accordo = acc[px]; //scelta la nota dell'accordo'
			nota_accordo += (py * 12); //saltiamo di 12 posizioni per passare all'ottava successiva
			nota_accordo += rapp.data.start_note; //Aggiustiamo la posizione in base alla starting note

			let s = `NOTA SCELTA prima: ${nota_accordo} `;

			//Controllo se la nota entra nel novero dello strumento e successivo adattamento
			//Controllo se la nota entra nel novero dello strumento e successivo adattamento
			while (nota_accordo > maxminnota[1]) {
				nota_accordo -= 12;
			}
			while (nota_accordo < maxminnota[0]) {
				nota_accordo += 12;
			}
			if (nota_accordo < 0) nota_accordo = 0;
			if (nota_accordo > maxminnota[1]) nota_accordo = maxminnota[1];
			//Controllo se la nota entra nel novero dello strumento e successivo adattamento
			//Controllo se la nota entra nel novero dello strumento e successivo adattamento

			s += `dopo: ${nota_accordo} || maxminnota: ${maxminnota[0]} : ${maxminnota[1]}`;

			if (rTComment) console.log(s);

			let nota = noteFreqs[nota_accordo]; //nota finale


			let dur = beatsToTime(n[1], rBeat);
			let pos = beatsToTime(n[2], rBeat);

			/**Se vogliamo fare in modo che la nota diventi lunga quanto il sample allora mettiamo adjustduration true, il triggerattack la farà durare quanto il sample! */
			let adjustduration = false;
			if (inst.name == "Ambient") adjustduration = true;

			if (rTComment) console.log(`${rapp.data.instrument.name} - nota-${nota} nota_accordo: ${nota_accordo} durata: ${dur.toFixed(3)} nsequences: ${k} di ${noteSequence.notes.length}`);

			rapp.data.notes.push(
				{
					sym: noteNames[nota_accordo], //Simbolo A2, C0...
					note: nota, //frequenza
					note_pos: nota_accordo, //posizione in seno all'array
					duration: dur,
					position: pos, //posizione in secondi nella timeline del transport
					velocity: n[3] * gain,
					pan: n[4],
					portamento: n[5],
					adjustduration: adjustduration
				}
			);
		});
		//l'assegnazione è ok, torniamo true!!
		return true;
	},
	/**richiama l'output dello strumento*/
	output() {
		//se stiamo suonando
		//		if (this.data.playing) {
		this.data.output();
		//		if (rTComment)  console.log(`output: ${this.data.isleID}`);
		//		}
	}

}


/**SEQUENCER */
/**SEQUENCER */

//CONST
//CONST
const noteValues = {
	'C0': 16.35, 'C#0': 17.32, 'D0': 18.35, 'D#0': 19.45, 'E0': 20.6, 'F0': 21.83, 'F#0': 23.12, 'G0': 24.5, 'G#0': 25.96, 'A0': 27.5, 'A#0': 29.14, 'B0': 30.87, 							//0->11
	'C1': 32.7, 'C#1': 34.65, 'D1': 36.71, 'D#1': 38.89, 'E1': 41.2, 'F1': 43.65, 'F#1': 46.25, 'G1': 49, 'G#1': 51.91, 'A1': 55, 'A#1': 58.27, 'B1': 61.74,								//12->23
	'C2': 65.41, 'C#2': 69.3, 'D2': 73.42, 'D#2': 77.78, 'E2': 82.41, 'F2': 87.31, 'F#2': 92.5, 'G2': 98, 'G#2': 103.83, 'A2': 110, 'A#2': 116.54, 'B2': 123.47,							//24->35
	'C3': 130.81, 'C#3': 138.59, 'D3': 146.83, 'D#3': 155.56, 'E3': 164.81, 'F3': 174.61, 'F#3': 185, 'G3': 196, 'G#3': 207.65, 'A3': 220, 'A#3': 233.08, 'B3': 246.94,						//36->47
	'C4': 261.63, 'C#4': 277.18, 'D4': 293.66, 'D#4': 311.13, 'E4': 329.63, 'F4': 349.23, 'F#4': 369.99, 'G4': 392, 'G#4': 415.3, 'A4': 440, 'A#4': 466.16, 'B4': 493.88,					//48->59
	'C5': 523.25, 'C#5': 554.37, 'D5': 587.33, 'D#5': 622.25, 'E5': 659.25, 'F5': 698.46, 'F#5': 739.99, 'G5': 783.99, 'G#5': 830.61, 'A5': 880, 'A#5': 932.33, 'B5': 987.77,				//60->71
	'C6': 1046.5, 'C#6': 1108.73, 'D6': 1174.66, 'D#6': 1244.51, 'E6': 1318.51, 'F6': 1396.91, 'F#6': 1479.98, 'G6': 1567.98, 'G#6': 1661.22, 'A6': 1760, 'A#6': 1864.66, 'B6': 1975.53,	//72->83
	'C7': 2093, 'C#7': 2217.46, 'D7': 2349.32, 'D#7': 2489.02, 'E7': 2637.02, 'F7': 2793.83, 'F#7': 2959.96, 'G7': 3135.96, 'G#7': 3322.44, 'A7': 3520, 'A#7': 3729.31, 'B7': 3951.07,		//84->95
	'C8': 4186.01, 'C#8': 4434.92, 'D8': 4698.63, 'D#8': 4978.03, 'E8': 5274.04, 'F8': 5587.65, 'F#8': 5919.91, 'G8': 6271.93, 'G#8': 6644.88, 'A8': 7040, 'A#8': 7458.62, 'B8': 7902.13	//96->107
}

const noteNames = ['C0', 'C#0', 'D0', 'D#0', 'E0', 'F0', 'F#0', 'G0', 'G#0', 'A0', 'A#0', 'B0', 'C1', 'C#1', 'D1', 'D#1', 'E1', 'F1', 'F#1', 'G1', 'G#1', 'A1', 'A#1', 'B1', 'C2', 'C#2', 'D2', 'D#2', 'E2', 'F2', 'F#2', 'G2', 'G#2', 'A2', 'A#2', 'B2', 'C3', 'C#3', 'D3', 'D#3', 'E3', 'F3', 'F#3', 'G3', 'G#3', 'A3', 'A#3', 'B3', 'C4', 'C#4', 'D4', 'D#4', 'E4', 'F4', 'F#4', 'G4', 'G#4', 'A4', 'A#4', 'B4', 'C5', 'C#5', 'D5', 'D#5', 'E5', 'F5', 'F#5', 'G5', 'G#5', 'A5', 'A#5', 'B5', 'C6', 'C#6', 'D6', 'D#6', 'E6', 'F6', 'F#6', 'G6', 'G#6', 'A6', 'A#6', 'B6', 'C7', 'C#7', 'D7', 'D#7', 'E7', 'F7', 'F#7', 'G7', 'G#7', 'A7', 'A#7', 'B7', 'C8', 'C#8', 'D8', 'D#8', 'E8', 'F8', 'F#8', 'G8', 'G#8', 'A8', 'A#8', 'B8'];

const noteFreqs = [16.35, 17.32, 18.35, 19.45, 20.6, 21.83, 23.12, 24.5, 25.96, 27.5, 29.14, 30.87, 32.7, 34.65, 36.71, 38.89, 41.2, 43.65, 46.25, 49, 51.91, 55, 58.27, 61.74, 65.41, 69.3, 73.42, 77.78, 82.41, 87.31, 92.5, 98, 103.83, 110, 116.54, 123.47, 130.81, 138.59, 146.83, 155.56, 164.81, 174.61, 185, 196, 207.65, 220, 233.08, 246.94, 261.63, 277.18, 293.66, 311.13, 329.63, 349.23, 369.99, 392, 415.3, 440, 466.16, 493.88, 523.25, 554.37, 587.33, 622.25, 659.25, 698.46, 739.99, 783.99, 830.61, 880, 932.33, 987.77, 1046.5, 1108.73, 1174.66, 1244.51, 1318.51, 1396.91, 1479.98, 1567.98, 1661.22, 1760, 1864.66, 1975.53, 2093, 2217.46, 2349.32, 2489.02, 2637.02, 2793.83, 2959.96, 3135.96, 3322.44, 3520, 3729.31, 3951.07, 4186.01, 4434.92, 4698.63, 4978.03, 5274.04, 5587.65, 5919.91, 6271.93, 6644.88, 7040, 7458.62, 7902.13];



/**
Esiste la struttura di ogni strumento. in base alle note del sequencer verrà inizializzato 
(così avremo solo strumenti e note necessari.)
inst: ciò che c'è a disposizione. ci sono le funzioni play e canplay che controllano l'array di strumenti inizializzati
e li fanno suonare 

QUANDO si seleziona uno strumento attivandolo (addInstrument), inst acquisisce un array di Tone.Strumento inizializzati e pronti all'uso e 
quando si attiva inst.play sceglie automaticamente lo strumento dopo l'ultimo ad aver suonato.'  


Solo: quanti di questi strumenti possono suonare contemporaneamente
*/
const rInstruments = {


	inst: [
		{ id: 0, name: 'Mono Synth', type: 'MonoSynth', lowest_note: 5, highest_note: 107, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '', },
		{ id: 1, name: 'Poly Synth', type: 'PolySynth', lowest_note: 5, highest_note: 107, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '', },
		{ id: 2, name: 'Membrane', type: 'MembraneSynth', lowest_note: 5, highest_note: 70, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '', },
		{ id: 3, name: 'Metal synth', type: 'MetalSynth', lowest_note: 40, highest_note: 60, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '', },
		{ id: 4, name: 'FM Synth', type: 'FMSynth', lowest_note: 5, highest_note: 70, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '', },
		{ id: 5, name: 'Am Synth', type: 'AMSynth', lowest_note: 5, highest_note: 70, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '', },
		{ id: 6, name: 'Piano salamander 1', type: 'Sampler', lowest_note: 12, highest_note: 84, maxinst: 3, offset: 0, base_volume: 0.8, solo: 10, nr_playing: 0, base_url: '/audio/salamander/', },
		{ id: 7, name: 'Gamelan sampler', type: 'Sampler', lowest_note: 0, highest_note: 109, maxinst: 3, offset: 0, base_volume: 0.6, solo: 10, nr_playing: 0, base_url: '/audio/gamelful/', },
		{ id: 8, name: 'Cello vibrato', type: 'Sampler', lowest_note: 24, highest_note: 61, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '/audio/cellovibrato/', },
		{ id: 9, name: 'Cello pizzicato', type: 'Sampler', lowest_note: 22, highest_note: 61, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '/audio/cellopizzicato/', },
		{ id: 10, name: 'TAICO', type: 'Sampler', lowest_note: 0, highest_note: 3, maxinst: 3, offset: 0, base_volume: 0.6, solo: 10, nr_playing: 0, base_url: '/audio/percussions/', },
		{ id: 11, name: 'Flute 1', type: 'Sampler', lowest_note: 21, highest_note: 60, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '/audio/flute/', },
		{ id: 12, name: 'Flute 2', type: 'Sampler', lowest_note: 21, highest_note: 60, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '/audio/flute/', },
		{ id: 13, name: 'Sitar', type: 'Sampler', lowest_note: 0, highest_note: 1, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '/audio/sitar/', },
		{ id: 14, name: 'Gamelan BONANG', type: 'Sampler', lowest_note: 0, highest_note: 51, maxinst: 3, offset: 0, base_volume: 0.6, solo: 10, nr_playing: 0, base_url: '/audio/gamelful/', },
		{ id: 15, name: 'Gamelan DRUMS', type: 'Sampler', lowest_note: 0, highest_note: 7, maxinst: 3, offset: 0, base_volume: 0.7, solo: 10, nr_playing: 0, base_url: '/audio/gamelful/', },
		{ id: 16, name: 'Gamelan GAMBANG', type: 'Sampler', lowest_note: 0, highest_note: 43, maxinst: 3, offset: 0, base_volume: 0.6, solo: 10, nr_playing: 0, base_url: '/audio/gamelful/', },
		{ id: 17, name: 'Gamelan GENDER', type: 'Sampler', lowest_note: 0, highest_note: 75, maxinst: 3, offset: 0, base_volume: 0.6, solo: 10, nr_playing: 0, base_url: '/audio/gamelful/', },
		{ id: 18, name: 'Gamelan GONG', type: 'Sampler', lowest_note: 0, highest_note: 29, maxinst: 3, offset: 0, base_volume: 0.6, solo: 10, nr_playing: 0, base_url: '/audio/gamelful/', },
		{ id: 19, name: 'Gamelan KEMPYANG', type: 'Sampler', lowest_note: 0, highest_note: 3, maxinst: 3, offset: 0, base_volume: 0.6, solo: 10, nr_playing: 0, base_url: '/audio/gamelful/', },
		{ id: 20, name: 'Gamelan KENONG', type: 'Sampler', lowest_note: 0, highest_note: 23, maxinst: 3, offset: 0, base_volume: 0.6, solo: 10, nr_playing: 0, base_url: '/audio/gamelful/', },
		{ id: 21, name: 'Gamelan KETHUK', type: 'Sampler', lowest_note: 0, highest_note: 3, maxinst: 3, offset: 0, base_volume: 0.6, solo: 10, nr_playing: 0, base_url: '/audio/gamelful/', },
		{ id: 22, name: 'Gamelan SARON', type: 'Sampler', lowest_note: 0, highest_note: 43, maxinst: 3, offset: 0, base_volume: 0.6, solo: 10, nr_playing: 0, base_url: '/audio/gamelful/', },
		{ id: 23, name: 'Percussions1', type: 'Sampler', lowest_note: 0, highest_note: 99, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '/audio/percussions/', },
		{ id: 24, name: 'Percussions2', type: 'Sampler', lowest_note: 0, highest_note: 99, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '/audio/percussions/', },
		{ id: 25, name: 'Percussions3', type: 'Sampler', lowest_note: 0, highest_note: 49, maxinst: 3, offset: 0, base_volume: 0.4, solo: 10, nr_playing: 0, base_url: '/audio/percussions/', },
		{ id: 26, name: 'Ambient', type: 'Sampler', lowest_note: 0, highest_note: 5, maxinst: 1, offset: 0, base_volume: 0.5, solo: 1, nr_playing: 0, base_url: '/audio/ambient/', },

	],
	/**ritorna lo strumento sopra */
	getInstrument(id) {
		return this.inst[id];
	},
	/**
		SE LO STRUMENTO NON È UN SAMPLER RITORNA FALSE
		Prepara gli urls che andranno nel costruttore del tone.sampler
		notes: array di posizioni delle note che ci interessano
	*/
	getSampleUrlsObject(instr_pos = 0, notes = []) {
		/**recuperati i paramtri strumento*/
		let ins = this.inst[instr_pos];

		/**
		l'oggetto per l'inizializzazione dello strumento Tone che esportiamo.
		se avremo dei sample la forma sarà
		{
			'A3': 'mario.mp3',
			'A4': 'mario2.mp3',
		}
		*/
		let ret = {}

		if (ins.type != "Sampler") return ret;

		notes.forEach((e) => {
			/**recuperiamo il sample della nota sotto */
			let note = rNotes[e];
			let sample = note.samples[instr_pos];

			/**Se esiste un sample lo aggiungiamo directly*/
			if (sample != 0) {
				/**recuperiamo il valore del sample corrispondente e lo aggiungiamo all'oggetto!! in uscita*/
				ret[note.name] = sample;

			} else { //ATTENTION! LA NOTA NON SI È TROVATA, scegliamo quella più vicina andando su e giù
				let oplus = e + 1;
				let ominus = e - 1;
				//ripetiamo su e giù cercando il sample più vicino finchè non esauriamo le note o lo troviamo!!
				while (oplus < rNotes.length && ominus > 0) {
					//scendiamo in basso
					if (oplus < rNotes.length) {
						note = rNotes[oplus++];
						sample = note.samples[instr_pos];
						if (sample != 0) {
							ret[note.name] = sample;
							break;
						}
					}
					//andiamo in alto
					if (ominus > 0) {
						note = rNotes[ominus--];
						sample = note.samples[instr_pos];
						if (sample != 0) {
							ret[note.name] = sample;
							break;
						}
					}
				}
			}
		});
		return ret;
	},
	/**prende le isole e inizializza gli strumenti! necessari a far suonare i sequencers*/
	initInstrumentsFromIsles(isles) {
		/**Segnaposto per strumenti/note */

		/** Set di strumenti-note
		{
			idstrumento: [
				{
					idnota: ,
					num: 
				}
			]
		}
		*/
		let rapp = this;
		let nnn = {};

		//SELEZIONE NOTE UTILIZZATE
		isles.forEach((isle) => {
			/**Se è stato definito un sequencer procediamo*/
			if (isle.sequencer !== undefined) {
				let seq = isle.sequencer;
				let instID = seq.data.instrumentPosition; //posizione strumento

				//Se non c'è un certo strumento lo creiamo
				if (nnn[instID] === undefined) {
					nnn[instID] = {};
				}

				//Per ogni nota della sequenza creiamo la proprietà con l'ID della nota ed uil numero di utilizzi
				seq.data.notes.forEach((n) => {
					let noteID = n.note_pos;
					if (nnn[instID][noteID] === undefined) {
						nnn[instID][noteID] = 0;
					} else {
						nnn[instID][noteID]++; //Aumentiamo il numero di note utilizzate 
					}
				});


			}
		});

		//Array per poter utilizzare il foreach sotto!
		let idStrumenti = Object.keys(nnn);

		/**TODO: dodaj da incrementira stevilo instrumentov glede na stevilo not ki jih ima sequencer! Kontrola, da ne bo prevece instrumentov (i lahko dodal funkcijo ki pove koiko jih je naenkrat etc..) */
		idStrumenti.forEach((n) => {
			//i keys che sono le note della sequenza diventano un'array di note scelte
			let notearray = nnn[n].noteArray = Object.keys(nnn[n]).map(Number); //trasforma le stringhe in integers!
			let inst = nnn[n].instrument = rInstruments.inst[n];

			//			//se lo strumento è un sampler allora aggiungigli i parametri sampler
			//			if (inst.type == "Sampler") {
			//				inst.samplerUrlsObject = rapp.getSampleUrlsObject(inst.id, notearray);
			//			}
			//			//Aggiungiamo lo instrumento
			rapp.addInstrument(n, notearray);

		});

		/**aggiungiamo le funzioni play e canPlay per ogni strumento */
		rapp.inst.forEach((ins) => {

			/**controllo se esistono synths dello strumento che non stanno suonando. Se trova uno che può suonare lo ritorna, altrimenti ritorna false*/
			ins.canPlay = () => {
				/**Se ci sono synths */
				if (ins.synths) {

					let ret = false;
					//traversa ogni synth; se sta suonando ritornando true passa avanti, altrimenti lo seleziona e blocca every ritornando false   
					ins.synths.every((i) => {
						/**se lo strumento non sta suonando lo seleziona ed esce dalla funzione every*/
						if (!i.playing) {
							ret = i;
							return false;
						}
						return true;
					});

					return ret;

				} else {
					//non ci sono synths, ritorniamo false direttamente
					return false;
				}
			}

			/**traversa i synths a disposizione, se trova uno ibero lo fa suonare e lo ritorna, altrimenti ritorna false.
			Si differenzia dalla funzione sopra per l'automatico play quando possibile */
			ins.play = (seq_data) => {
				/**Se ci sono synths */
				if (ins.synths) {

					let ret = false;
					//traversa ogni synth; se sta suonando ritornando true passa avanti, altrimenti lo seleziona e blocca every ritornando false   
					ins.synths.every((i) => {
						/**se lo strumento non sta suonando lo seleziona ed esce dalla funzione every*/
						if (!i.playing) {
							//facciamo suonare il synth con lo slot libero!
							i.play(seq_data);

							ret = i;
							return false;
						}
						return true;
					});

					return ret;

				} else {
					//non ci sono synths, ritorniamo false direttamente
					return false;
				}

			}
			/**traversa i synth e ne fa suonare l'output! */
			ins.output = () => {

			}
			/** */
			ins.playingIsleID = 0;

		});

		if (rTComment) console.log('bo slo', rapp);
		//		throw ('konec');
	},
	/**Inizializza lo strumento aggiungendolo all'array strumenti!
	Va utilizzato DOPO getSampleUrlsObject.
	notes: le note che andiamo ad inizializzare nei sampler!! (per non loadare tutte le possibili, non ciservono!)
	*/
	addInstrument(instID, notes) {
		let rapp = this;
		let inst = rapp.inst[instID]; //lo strumento dall'array rapp.inst
		let synths = inst.synths; //segnaposto per la lista di synths
		let synth = false; //segnaposto dretto strumento nella lista sopra
		let iID = parseInt(instID);

		//numero di synths nell'array
		let nr_synths = parseInt(inst.maxinst);

		for (let i = 0; i < nr_synths; i++) {

			switch (true) {
				case iID == 0:
					synth = {
						device: new Tone.MonoSynth({
							volume: -8,
							oscillator: { type: "square" },
							envelope: { attack: 0.1, attackCurve: "exponential", decay: .3, decayCurve: "linear", sustain: .5, release: 2, releaseCurve: "linear" },
							filterEnvelope: { attack: 0.001, decay: 0.7, sustain: 0.1, release: 2, baseFrequency: 100, octaves: 3 },
							portamento: 1
						}),
						sampler: false, //per distinguere facilmente il synth se è sampler
						playing: false,
						ready: true
					}
					//aggiungiamo il synth alla lista dei synths
					if (synths == undefined) {
						synths = rapp.inst[instID].synths = [synth];
					} else {
						synths.push(synth);
					}
					break;
				case iID == 1:
					synth = {
						device: new Tone.PolySynth(Tone.MonoSynth, {
							volume: -8,
							oscillator: {
								type: "square8"
							},
							envelope: { attack: 0.05, decay: 0.3, sustain: 0.4, release: 0.8, },
							filterEnvelope: { attack: 0.001, decay: 0.7, sustain: 0.1, release: 0.8, baseFrequency: Math.random() * 400 + 20, octaves: 4 },
							portamento: 1
						}),
						sampler: false,
						playing: false,
						ready: true
					}
					//aggiungiamo il synth alla lista dei synths
					if (synths == undefined) {
						synths = rapp.inst[instID].synths = [synth];
					} else {
						synths.push(synth);
					}
					break;
				case iID == 2:
					synth = {
						device: new Tone.PolySynth(Tone.MembraneSynth, {
							pitchDecay: 0.008,
							octaves: 2,
							envelope: { attack: 0.001, decay: 0.5, sustain: .03 },
							portamento: 1
						}),
						sampler: false,
						playing: false,
						ready: true
					}
					//aggiungiamo il synth alla lista dei synths
					if (synths == undefined) {
						synths = rapp.inst[instID].synths = [synth];
					} else {
						synths.push(synth);
					}
					break;
				case iID == 3:
					synth = {
						device: new Tone.PolySynth(Tone.MetalSynth, {
							harmonicity: 12,
							resonance: 800,
							portamento: 1,
							modulationIndex: 20,
							envelope: { attack: 0.03, decay: .5, sustain: 0.7, release: 1 }
						}),
						sampler: false,
						playing: false,
						ready: true
					}
					//aggiungiamo il synth alla lista dei synths
					if (synths == undefined) {
						synths = rapp.inst[instID].synths = [synth];
					} else {
						synths.push(synth);
					}
					break;
				case iID == 4:
					synth = {
						device: new Tone.FMSynth({
							release: 1,
							portamento: 1
						}),
						sampler: false,
						playing: false,
						ready: true
					}
					//aggiungiamo il synth alla lista dei synths
					if (synths == undefined) {
						synths = rapp.inst[instID].synths = [synth];
					} else {
						synths.push(synth);
					}
					break;
				case iID == 5:
					synth = {
						device: new Tone.FMSynth({
							release: 1,
							portamento: 1
						}),
						playing: false,
						sampler: false,
						ready: true
					}
					//aggiungiamo il synth alla lista dei synths
					if (synths == undefined) {
						synths = rapp.inst[instID].synths = [synth];
					} else {
						synths.push(synth);
					}
					break;
				case iID >= 6: //Sampler: si inizializzano dalle note gli url che servono!!
					/**OPTIONS: 
						attack : Time
						baseUrl : string
						context : BaseContext
						curve : ToneBufferSourceCurve
						onerror : (error) =>void
						onload : () =>void
						release : Time
						urls : SamplesMap
						volume : Decibels
	
					 */
					let urls = rapp.getSampleUrlsObject(iID, notes);
					synth = {
						device: new Tone.Sampler({
							baseUrl: inst.base_url,
							urls: urls,
							//							envelope: {
							//								attack: 0.05,
							//								decay: 0.3,
							//								sustain: 0.4,
							//								release: 2,
							//							},
							release: 2, //margine per i samples lunghi
							onload: () => {
								synth.ready = true;

								synth.durations = [];
								let buf = Array.from(synth.device._buffers._buffers.values());

								buf.forEach((v) => {
									synth.durations.push(v.duration);
								});

								//oggetto con le durations; il key sarà la nota in notazione!!!
								//								synth.durations = {};
								//								//Convertiamo i buffers in array!
								//								let buf = Array.from(synth.device._buffers._buffers.values());
								//
								//								let i = 0;
								//								for (let urlo in urls) {
								//									synth.durations[urlo] = buf[i++].duration;
								//
								//								}
								if (rTComment) console.log(`SYNTH durations: `, synth.durations);
							}
						}),
						playing: false,
						ready: false,
						sampler: true,
					}
					//esterna per permettere l'inizializzazione dell'oggetto;
					//				readyFunction=()=>{
					//					synth.ready=true;
					//				}

					//aggiungiamo il synth alla lista dei synths
					if (synths == undefined) {
						synths = rapp.inst[instID].synths = [synth];
					} else {
						synths.push(synth);
					}

					//				throw ('yazzo');
					break;
			}
			//Se scegliemmo il synth, altrimenti sarà player(TODO)!

			if (synth) {

				//aggiungiamo riferimento allo strumento padre (dall'array inst sopra)
				synth.inst = inst;

				//creiamo e colleghiamo il volume DECIBELS, d 0->130 logaritmico, base_volume 0->1
				let volume = synth.volume = new Tone.Volume(inst.base_volume * 30);
				synth.device.connect(volume);
				//creiamo e colleghiamo la spazialità 3d
				let p3d = synth.panner3D = new Tone.Panner3D();
				volume.connect(p3d);
				//creiamo e colleghiamo l'output'
				synth.rms = new Tone.DCMeter({
					normalRange: true
				});
				//				p3d.connect(rms);
				//linkiamo all'uscita
				p3d.toDestination();
				//sincronizziamo a tone.trasport
				synth.device.sync();

				//creiamo la funzione PLAY
				synth.play = (sequencer_data) => {

					let ret = false;
					//Nel caso lo strumento stia suonando usciamo con false;

					//DEBUGGG
					//DEBUGGG Se playing che vi sia un'altro a suonare, non fermare la baracca!

					//Nel caso il numero di strumenti che possono suonare allo stesso tempo superi il numero consentito esci
					if (inst.nr_playing >= inst.solo) {
						//si incrementiral v sequencer.play!
						sequencer_data.decrement_sounds();

						if (rTComment) console.log(`KLINC ${inst.name} playing: ${inst.nr_playing} solo: ${inst.solo}`);
						return false;
					}
					//DEBUGGG
					//DEBUGGG

					//altrimenti continuiamo 
					if (synth.ready) {
						synth.volume.value = inst.base_volume * 30;
						synth.panner3D.set({
							//				distanceModel: props.generalData.distanceModel,
							//				maxDistance: props.generalData.maxDistance,
							//				panningModel: props.generalData.panningModel,
							//				refDistance: props.generalData.refDistance,
							position: sequencer_data.isle_position
						});

						//CONNESSIONE DEL METER
						synth.panner3D.fan(synth.rms);

						//parametri per l'utput!					
						synth.texAudioAddressActive = sequencer_data.texAudioAddressActive;
						synth.texAudioAddressData = sequencer_data.texAudioAddressData;

						/**Trasferiamo l'output del synth al sequencer, 
						per poter trasferire l'rms dal sytnh al sequencer prima e all'isola dopo!*/
						sequencer_data.output = synth.output;

						//DEBUG PLAYING
						//DEBUG PLAYING
						//stiamo suonando il synth
						synth.playing = true;
						/**il presente sequencer sta suonando */
						sequencer_data.playing = true;
						//aumentiamo il numero di sintetizzatori di questo strumento che stanno suonando
						inst.nr_playing++;

						//sequencer_data.increment_sounds(); //SI GA ZE UPORABIL V SEQUENCER.PLAY!
						//DEBUG PLAYING
						//DEBUG PLAYING


						//avvertiamo i shaders che il synth associato all'isola sta suonando
						window.texData[sequencer_data.texAudioAddressActive] = 1;

						//fine della riproduzione strumento					
						let endTime = 0;


						//da usare per le singole note

						/**il play della nota*/
						let time = window.rTone.Transport.now();

						if (rTComment) console.log(`PLAY ${inst.name} inst nr.playing: ${inst.nr_playing} instmax contemporary: ${inst.solo} time ${time}`);

						//lo strumento TONE!
						let device = synth.device;

						/**per ogni situazione di nota */
						sequencer_data.notes.every(function(n, i) {
							//la schedule quando parte la ripetizione

							if ('portamento' in device) {
								device.portamento = n.portamento;
								if (rTComment) console.log(`GO Portmanto! ${synth.inst.name} portamento: ${n.portamento}`);
							}

							//nel caso si tratti di sampler e ci sia la adjust duration aggiustiamo la durata della nota!
							if (synth.sampler && n.adjustduration) {
								//calculate sample position
								n.duration = 1;
								let np = (inst.highest_note - inst.lowest_note) * (n.note_pos - inst.lowest_note); //note position
								let sp = parseInt(np * synth.durations.length); //sample position
								//alcuni samples risultano di zero length!!
								if (synth.durations[sp] > 0) n.duration = synth.durations[sp];
							}

							let pos = time + sequencer_data.start_time + n.position;

							let tempEndTime = pos + n.duration;


							//Se sforiamo la DURATA DELL'ANIMAZIONE il foreach si interrompe
							if (tempEndTime < Tone.Transport.rPos.dur) {
								device.triggerAttackRelease(n.sym, n.duration, pos, n.velocity);
								endTime = tempEndTime; //l'ultima nota + la sua durata determina la fine della sequenza
								if (rTComment) console.log(`--> NOTA ${synth.inst.name} i: ${i} n: ${n.sym} IsleID: ${sequencer_data.isleID} Vel: ${n.velocity.toFixed(2)} Pos: ${pos.toFixed(2)} Dur: ${n.duration.toFixed(2)} End: ${endTime.toFixed(2)} Animation length: ${Tone.Transport.rPos.dur}`);
								return true;

							}
							if (rTComment) console.log(`ma ke klinc i: ${i} ${synth.inst.name} n: ${n.sym} IsleID: ${sequencer_data.isleID} Pos: ${pos.toFixed(2)} Dur: ${n.duration.toFixed(2)} End: ${endTime.toFixed(2)} Animation length: ${Tone.Transport.rPos.dur}`)
							return false;
						});

						/**A metà sequenza parte la prossima */
						/**DEBUG - ENDTIME INTERO */
						//						let dur = (endTime - time);
						//						if (dur > 5) endTime -= (dur / 2);
						/**DEBUG - ENDTIME INTERO */


						/**Alla fine di tutto rilasciamo lo strumento per permettere un nuovo play */
						//					params.endID[0] = window.rTone.Transport.schedule(function(time) {

						Tone.Transport.scheduleOnce(function(time) {

							/**il presente sequencer non sta suonando più */
							sequencer_data.playing = false;

							/** Impostiamo come non suonante lo strumento */
							synth.playing = false;
							//decrementiamo il numero di strumenti dello stesso tipo che stanno suonando
							inst.nr_playing--;

							/** Impostiamo nella texture audio */
							//							window.texData[sequencer_data.texAudioAddressData] = 0;
							window.texData[sequencer_data.texAudioAddressActive] = 0;

							synth.active = false;

							synth.device.triggerRelease();
							//							synth.device.disconnect();

							//DISCONNESSIONE DEL METER
							synth.panner3D.disconnect(synth.rms);

							sequencer_data.decrement_sounds();

							if (rTComment) console.log(` ## END PLAY ${synth.inst.name} dur inst nr.playing: ${inst.nr_playing} instmax contemporary: ${inst.solo}  time ${time.toFixed(2)} tone.now ${Tone.now().toFixed(2)} endtime ${endTime.toFixed(2)}`);

						}, endTime);

						ret = true; //lo strumento ha avviato la procedura del suono
						//			if (rTComment)  console.log('play inst', props.isleID, props.instrumentID, props);

					}
					return ret;
				} //end synth.play

				//Uscita x i dati ahader
				synth.output = () => {
					if (synth.playing && synth.ready) {
						//						let rms = synth.rms.getValue() * destination_rms.getValue();
						let rms = synth.rms.getValue();

						let v0 = Math.pow(rms, (1 - Math.pow(rms), 0.1)); //facciamo una funzione decente per il volume per aumentare la steepness della curva
						let vv = Math.log2(Math.pow(rms, 0.5) + 1); //facciamo una funzione decente per il volume per aumentare la steepness della curva

						/**posizione in seno alla texture adudiodati del parametro!*/
						//					window.texData[synth.texAudioAddressData] = (vv > 0.000001) ? vv : 0;


						//AVVICINAMENTO, non brutale!!
						window.texData[synth.texAudioAddressData] = window.texData[synth.texAudioAddressData] + (v0 - window.texData[synth.texAudioAddressData]) * .02;

						//						if (rTComment)  console.log(`Output id ${synth.texAudioAddressData}: ${window.texData[synth.texAudioAddressData].toFixed(4)} ${synth.rms.getValue().toFixed(4)} ${vv.toFixed(4)} ${v0.toFixed(4)}`);

					} else { //altrimenti scriviamo zeri (per esser sicuri che l'isola non sia attiva)
						/**posizione in seno alla texture adudiodati del parametro!*/
						//						window.texData[synth.texAudioAddressData] = 0;
						if (window.texData[synth.texAudioAddressData] > 0.001) {
							window.texData[synth.texAudioAddressData] *= .05;
						} else if (window.texData[synth.texAudioAddressData] > 0) {
							window.texData[synth.texAudioAddressData] = 0;
						}

					}

				}
			}
		}
	},
}

/**LE NOTE CON I SAMPLES - constructed via Calc! */
const rNotes = [
	{ id: 0, name: `C0`, freq: 16.35, samples: [0, 0, 0, 0, 0, 0, 0, `drums-ciblon-medium-dlang.mp3`, 0, 0, `o_taiko_1.mp3`, 0, 0, `sitar01.mp3`, `bonang-bbpl1h.mp3`, `drums-ciblon-medium-dlang.mp3`, `gambang-gpl1hh.mp3`, `gender-gbpl1hh.mp3`, `gong-gaf.mp3`, `kempyang-kppl6.mp3`, `kenong-kpl1h.mp3`, `kethuk-ktpl6.mp3`, `saron-sbpl1.mp3`, `aerosol.mp3`, `j_cym1.mp3`, `swing.mp3`, `Amb, Field, Birds, Wind, MS_01.mp3`,] },
	{ id: 1, name: `C#0`, freq: 17.32, samples: [0, 0, 0, 0, 0, 0, 0, `drums-ciblon-medium-lung.mp3`, 0, 0, `o_taiko1side.mp3`, 0, 0, `sitar02.mp3`, `bonang-bbpl1.mp3`, `drums-ciblon-medium-lung.mp3`, `gambang-gpl1h.mp3`, `gender-gbpl1h.mp3`, `gong-gap.mp3`, `kempyang-kppl6s.mp3`, `kenong-kpl1hs.mp3`, `kethuk-ktpl6s.mp3`, `saron-sbpl2.mp3`, `afrobell1.mp3`, `j_cym2.mp3`, `syn_bata_h.mp3`, `Amb, Forest, Birds, Geese, Wind, MS_01.mp3`,] },
	{ id: 2, name: `D0`, freq: 18.35, samples: [0, 0, 0, 0, 0, 0, 0, `drums-ciblon-medium-tak.mp3`, 0, 0, `o_taiko2side.mp3`, 0, 0, 0, `bonang-bbpl2h.mp3`, `drums-ciblon-medium-tak.mp3`, `gambang-gpl1l.mp3`, `gender-gbpl1.mp3`, `gong-gkpl1f.mp3`, `kempyang-kpsl1.mp3`, `kenong-kpl2.mp3`, `kethuk-ktsl2.mp3`, `saron-sbpl3.mp3`, `afrobell2.mp3`, `jinglebell1.mp3`, `syn_bata_m.mp3`, `birds_outside_002_wide.mp3`,] },
	{ id: 3, name: `D#0`, freq: 19.45, samples: [0, 0, 0, 0, 0, 0, 0, `drums-ciblon-medium-thung.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbpl2.mp3`, `drums-ciblon-medium-thung.mp3`, `gambang-gpl1.mp3`, `gender-gbpl2hh.mp3`, `gong-gkpl1p.mp3`, `kempyang-kpsl1s.mp3`, `kenong-kpl2s.mp3`, `kethuk-ktsl2s.mp3`, `saron-sbpl4.mp3`, `afrobell3.mp3`, `ji_perc.mp3`, `syn_bata_mu.mp3`, `FLWA 07 - Creek, water, flowing, splashing.mp3`,] },
	{ id: 4, name: `E0`, freq: 20.6, samples: [0, 0, 0, 0, 0, 0, 0, `drums-ciblon-medium-tong.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbpl3h.mp3`, `drums-ciblon-medium-tong.mp3`, `gambang-gpl2hh.mp3`, `gender-gbpl2h.mp3`, `gong-gkpl2f.mp3`, 0, `kenong-kpl3.mp3`, 0, `saron-sbpl5.mp3`, `afrobell4.mp3`, `j_wood_block2.mp3`, `syn_b.mp3`, `Forest quiet birds and wind the morning_140313_00.mp3`,] },
	{ id: 5, name: `F0`, freq: 21.83, samples: [0, 0, 0, 0, 0, 0, 0, `drums-kendhang-ageng-dha.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbpl3.mp3`, `drums-kendhang-ageng-dha.mp3`, `gambang-gpl2h.mp3`, `gender-gbpl2.mp3`, `gong-gkpl2p.mp3`, 0, `kenong-kpl3s.mp3`, 0, `saron-sbpl6.mp3`, `ahh2.mp3`, `j_wood_block3.mp3`, `syn_cabasa.mp3`, `W 04 Water_05_Cave, Ambience, Water Drops, River_T05.mp3`,] },
	{ id: 6, name: `F#0`, freq: 23.12, samples: [0, 0, 0, 0, 0, 0, 0, `drums-ketipung-small-dhung.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbpl4h.mp3`, `drums-ketipung-small-dhung.mp3`, `gambang-gpl2l.mp3`, `gender-gbpl3hh.mp3`, `gong-gkpl3f.mp3`, 0, `kenong-kpl5.mp3`, 0, `saron-sbpl7.mp3`, `ahh3.mp3`, `j_wood_block4.mp3`, `synconga_h.mp3`, 0,] },
	{ id: 7, name: `G0`, freq: 24.5, samples: [0, 0, 0, 0, 0, 0, 0, `drums-ketipung-small-tak.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbpl4.mp3`, `drums-ketipung-small-tak.mp3`, `gambang-gpl2.mp3`, `gender-gbpl3h.mp3`, `gong-gkpl3p.mp3`, 0, `kenong-kpl5s.mp3`, 0, `saron-sbsl1h.mp3`, `ahh.mp3`, `j_wood_block.mp3`, `synconga_h_slp.mp3`, 0,] },
	{ id: 8, name: `G#0`, freq: 25.96, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl1hh.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbpl5h.mp3`, 0, `gambang-gpl3hh.mp3`, `gender-gbpl3.mp3`, `gong-gkpl5f.mp3`, 0, `kenong-kpl6.mp3`, 0, `saron-sbsl1.mp3`, `ana_resonance.mp3`, `kick_jo_3__l.mp3`, `synconga_l_heel.mp3`, 0,] },
	{ id: 9, name: `A0`, freq: 27.5, samples: [0, 0, 0, 0, 0, 0, `a0v3.mp3`, `gambang-gpl1h.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbpl5.mp3`, 0, `gambang-gpl3h.mp3`, `gender-gbpl5h.mp3`, `gong-gkpl5p.mp3`, 0, `kenong-kpl6s.mp3`, 0, `saron-sbsl2h.mp3`, `angel_block.mp3`, `kniff_guiro2.mp3`, `synconga_l.mp3`, 0,] },
	{ id: 10, name: `A#0`, freq: 29.14, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl1l.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbpl6h.mp3`, 0, `gambang-gpl3l.mp3`, `gender-gbpl5.mp3`, `gong-gkpl6f.mp3`, 0, `kenong-kpl7.mp3`, 0, `saron-sbsl2.mp3`, `attack_fx.mp3`, `kniff_guiro.mp3`, `syn_crash.mp3`, 0,] },
	{ id: 11, name: `B0`, freq: 30.87, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl1.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbpl6.mp3`, 0, `gambang-gpl3.mp3`, `gender-gbpl6h.mp3`, `gong-gkpl6p.mp3`, 0, `kenong-kpl7s.mp3`, 0, `saron-sbsl3h.mp3`, `bata1.mp3`, `koeagkarim.mp3`, `syn_shake.mp3`, 0,] },
	{ id: 12, name: `C1`, freq: 32.7, samples: [0, 0, 0, 0, 0, 0, `c1v3.mp3`, `gambang-gpl2hh.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbpl7h.mp3`, 0, `gambang-gpl5hh.mp3`, `gender-gbpl6l.mp3`, `gong-gkpl7f.mp3`, 0, `kenong-ksl1h.mp3`, 0, `saron-sbsl3.mp3`, `bata2.mp3`, `koeagkari.mp3`, `syn_silen.mp3`, 0,] },
	{ id: 13, name: `C#1`, freq: 34.65, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl2h.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbpl7.mp3`, 0, `gambang-gpl5h.mp3`, `gender-gbpl6.mp3`, `gong-gkpl7p.mp3`, 0, `kenong-ksl1hs.mp3`, 0, `saron-sbsl5.mp3`, `bata_hi2.mp3`, `loose_sn.mp3`, `syn_sn_fx.mp3`, 0,] },
	{ id: 14, name: `D1`, freq: 36.71, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl2l.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbsl1hh.mp3`, 0, `gambang-gpl5l.mp3`, `gender-gbpl7h.mp3`, `gong-gksl1f.mp3`, 0, `kenong-ksl2h.mp3`, 0, `saron-sbsl6l.mp3`, `bata_hi.mp3`, `loplik.mp3`, `syn_stack_2.mp3`, 0,] },
	{ id: 15, name: `D#1`, freq: 38.89, samples: [0, 0, 0, 0, 0, 0, `dS1v3.mp3`, `gambang-gpl2.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbsl1h.mp3`, 0, `gambang-gpl5.mp3`, `gender-gbpl7l.mp3`, `gong-gksl1lf.mp3`, 0, `kenong-ksl2hs.mp3`, 0, `saron-sbsl6.mp3`, `bd_breath.mp3`, `machine_agogo.mp3`, `syn_stack_3.mp3`, 0,] },
	{ id: 16, name: `E1`, freq: 41.2, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl3hh.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbsl1.mp3`, 0, `gambang-gpl6h.mp3`, `gender-gbpl7.mp3`, `gong-gksl1lp.mp3`, 0, `kenong-ksl2.mp3`, 0, `saron-sdpl1.mp3`, `bell_3.mp3`, `machine_clave.mp3`, `syn_stack.mp3`, 0,] },
	{ id: 17, name: `F1`, freq: 43.65, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl3h.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbsl2hh.mp3`, 0, `gambang-gpl6ll.mp3`, `gender-gbsl1hh.mp3`, `gong-gksl1p.mp3`, 0, `kenong-ksl2s.mp3`, 0, `saron-sdpl2.mp3`, `bell_louis.mp3`, `machine_sn.mp3`, `syn_tabla.mp3`, 0,] },
	{ id: 18, name: `F#1`, freq: 46.25, samples: [0, 0, 0, 0, 0, 0, `fS1v3.mp3`, `gambang-gpl3l.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbsl2h.mp3`, 0, `gambang-gpl6l.mp3`, `gender-gbsl1h.mp3`, `gong-gksl2f.mp3`, 0, `kenong-ksl3.mp3`, 0, `saron-sdpl3.mp3`, `bell.mp3`, `maracas.mp3`, `synth_bell.mp3`, 0,] },
	{ id: 19, name: `G1`, freq: 49, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl3.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbsl2.mp3`, 0, `gambang-gpl6.mp3`, `gender-gbsl1.mp3`, `gong-gksl2lf.mp3`, 0, `kenong-ksl3s.mp3`, 0, `saron-sdpl4.mp3`, `big_taiko2.mp3`, `mealic_p.mp3`, `synth_drop.mp3`, 0,] },
	{ id: 20, name: `G#1`, freq: 51.91, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl5hh.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbsl3h.mp3`, 0, `gambang-gsl1hh.mp3`, `gender-gbsl2hh.mp3`, `gong-gksl2lp.mp3`, 0, `kenong-ksl5.mp3`, 0, `saron-sdpl5.mp3`, `big_taiko3.mp3`, `med_taiko.mp3`, `synth_metal.mp3`, 0,] },
	{ id: 21, name: `A1`, freq: 55, samples: [0, 0, 0, 0, 0, 0, `a1v3.mp3`, `gambang-gpl5h.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbsl3.mp3`, 0, `gambang-gsl1h.mp3`, `gender-gbsl2h.mp3`, `gong-gksl2p.mp3`, 0, `kenong-ksl5s.mp3`, 0, `saron-sdpl6.mp3`, `big_taiko.mp3`, `metal_01.mp3`, `synth_noiz_sn.mp3`, 0,] },
	{ id: 22, name: `A#1`, freq: 58.27, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl5l.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbsl5h.mp3`, 0, `gambang-gsl1l.mp3`, `gender-gbsl2.mp3`, `gong-gksl3f.mp3`, 0, `kenong-ksl6.mp3`, 0, `saron-sdpl7.mp3`, `birds_mix.mp3`, `metal_accent.mp3`, `syn_w_block.mp3`, 0,] },
	{ id: 23, name: `B1`, freq: 61.74, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl5.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbsl5.mp3`, 0, `gambang-gsl1.mp3`, `gender-gbsl3hh.mp3`, `gong-gksl3p.mp3`, 0, `kenong-ksl6s.mp3`, 0, `saron-sdsl1h.mp3`, `blox.mp3`, `metal_bell.mp3`, `tabla_high.mp3`, 0,] },
	{ id: 24, name: `C2`, freq: 65.41, samples: [0, 0, 0, 0, 0, 0, `c2v3.mp3`, `gambang-gpl6h.mp3`, 0, `2_c.mp3`, 0, `Flute_C2.mp3`, `Flute2_C2.mp3`, 0, `bonang-bbsl6h.mp3`, 0, `gambang-gsl2hh.mp3`, `gender-gbsl3h.mp3`, `gong-gksl5f.mp3`, 0, 0, 0, `saron-sdsl1.mp3`, `bodhran_wb.mp3`, `metal_block.mp3`, `tabla_low.mp3`, 0,] },
	{ id: 25, name: `C#2`, freq: 69.3, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl6ll.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bbsl6.mp3`, 0, `gambang-gsl2h.mp3`, `gender-gbsl3.mp3`, `gong-gksl5p.mp3`, 0, 0, 0, `saron-sdsl2.mp3`, `boing_1.mp3`, `metal_break.mp3`, `tamb_mix.mp3`, 0,] },
	{ id: 26, name: `D2`, freq: 73.42, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gpl6l.mp3`, `2_d.mp3`, `2_d.mp3`, 0, `Flute_D2.mp3`, 0, 0, `bonang-bppl1h.mp3`, 0, `gambang-gsl2l.mp3`, `gender-gbsl5h.mp3`, `gong-gksl6f.mp3`, 0, 0, 0, `saron-sdsl3.mp3`, `book.mp3`, `metal_fx_sn.mp3`, `tambourin2.mp3`, 0,] },
	{ id: 27, name: `D#2`, freq: 77.78, samples: [0, 0, 0, 0, 0, 0, `dS2v3.mp3`, `gambang-gpl6.mp3`, 0, 0, 0, 0, `Flute2_Dd2.mp3`, 0, `bonang-bppl1.mp3`, 0, `gambang-gsl2.mp3`, `gender-gbsl5.mp3`, `gong-gksl6p.mp3`, 0, 0, 0, `saron-sdsl5.mp3`, `book_rim.mp3`, `metal_perc_h.mp3`, `tambourin.mp3`, 0,] },
	{ id: 28, name: `E2`, freq: 82.41, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl1hh.mp3`, 0, `2_e.mp3`, 0, 0, 0, 0, `bonang-bppl2h.mp3`, 0, `gambang-gsl3hh.mp3`, `gender-gbsl6h.mp3`, `gong-gsf.mp3`, 0, 0, 0, `saron-sdsl6l.mp3`, `box_sn.mp3`, `metal_perc_l.mp3`, `techno_gun.mp3`, 0,] },
	{ id: 29, name: `F2`, freq: 87.31, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl1h.mp3`, 0, `2_f.mp3`, 0, 0, 0, 0, `bonang-bppl2.mp3`, 0, `gambang-gsl3h.mp3`, `gender-gbsl6l.mp3`, `gong-gsp.mp3`, 0, 0, 0, `saron-sdsl6.mp3`, `breath.mp3`, `metal_sn_2.mp3`, `templebl_h.mp3`, 0,] },
	{ id: 30, name: `F#2`, freq: 92.5, samples: [0, 0, 0, 0, 0, 0, `fS2v3.mp3`, `gambang-gsl1l.mp3`, `2_gb.mp3`, 0, 0, `Flute_Fd2.mp3`, `Flute2_Fd2.mp3`, 0, `bonang-bppl3h.mp3`, 0, `gambang-gsl3l.mp3`, `gender-gbsl6.mp3`, 0, 0, 0, 0, `saron-sppl1.mp3`, `but_sn.mp3`, `mojo_fast.mp3`, `templebl_l.mp3`, 0,] },
	{ id: 31, name: `G2`, freq: 98, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl1.mp3`, 0, `2_g.mp3`, 0, 0, 0, 0, `bonang-bppl3.mp3`, 0, `gambang-gsl3.mp3`, `gender-gppl1hh.mp3`, 0, 0, 0, 0, `saron-sppl2.mp3`, `cachichi.mp3`, `mojo_slow.mp3`, `templebl_m.mp3`, 0,] },
	{ id: 32, name: `G#2`, freq: 103.83, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl2hh.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bppl4h.mp3`, 0, `gambang-gsl5hh.mp3`, `gender-gppl1h.mp3`, 0, 0, 0, 0, `saron-sppl3.mp3`, `cajon.mp3`, `mp12x7sno8.mp3`, `tight_sn_fx.mp3`, 0,] },
	{ id: 33, name: `A2`, freq: 110, samples: [0, 0, 0, 0, 0, 0, `a2v3.mp3`, `gambang-gsl2h.mp3`, `2_a.mp3`, `2_a.mp3`, 0, `Flute_A2.mp3`, `Flute2_A2.mp3`, 0, `bonang-bppl4.mp3`, 0, `gambang-gsl5h.mp3`, `gender-gppl1.mp3`, 0, 0, 0, 0, `saron-sppl4.mp3`, `casta.mp3`, `naqqara_1.mp3`, `to_hhcl.mp3`, 0,] },
	{ id: 34, name: `A#2`, freq: 116.54, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl2l.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bppl5h.mp3`, 0, `gambang-gsl5l.mp3`, `gender-gppl2hh.mp3`, 0, 0, 0, 0, `saron-sppl5.mp3`, `changgo02.mp3`, `naqqara_2.mp3`, `tri_a.mp3`, 0,] },
	{ id: 35, name: `B2`, freq: 123.47, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl2.mp3`, 0, `2_b.mp3`, 0, 0, 0, 0, `bonang-bppl5.mp3`, 0, `gambang-gsl5.mp3`, `gender-gppl2h.mp3`, 0, 0, 0, 0, `saron-sppl6.mp3`, `changgo03.mp3`, `noise_bd2.mp3`, `triangle.mp3`, 0,] },
	{ id: 36, name: `C3`, freq: 130.81, samples: [0, 0, 0, 0, 0, 0, `c3v3.mp3`, `gambang-gsl3hh.mp3`, 0, `3_c.mp3`, 0, `Flute_C3.mp3`, `Flute2_C3.mp3`, 0, `bonang-bppl6h.mp3`, 0, `gambang-gsl6h.mp3`, `gender-gppl2.mp3`, 0, 0, 0, 0, `saron-sppl7.mp3`, `changgo_l2.mp3`, `noise_bd3.mp3`, `tsuzumi_1.mp3`, 0,] },
	{ id: 37, name: `C#3`, freq: 138.59, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl3h.mp3`, `3_db.mp3`, 0, 0, 0, 0, 0, `bonang-bppl6.mp3`, 0, `gambang-gsl6l.mp3`, `gender-gppl3hh.mp3`, 0, 0, 0, 0, `saron-spsl1h.mp3`, `changgo_l.mp3`, `noise_bd_4.mp3`, `tsuzumi_2.mp3`, 0,] },
	{ id: 38, name: `D3`, freq: 146.83, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl3l.mp3`, 0, `3_d.mp3`, 0, `Flute_D3.mp3`, 0, 0, `bonang-bppl7h.mp3`, 0, `gambang-gsl6.mp3`, `gender-gppl3h.mp3`, 0, 0, 0, 0, `saron-spsl1.mp3`, `changgo.mp3`, `noise_bd.mp3`, `tsuzumi_3.mp3`, 0,] },
	{ id: 39, name: `D#3`, freq: 155.56, samples: [0, 0, 0, 0, 0, 0, `dS3v3.mp3`, `gambang-gsl3.mp3`, 0, 0, 0, 0, `Flute2_Dd3.mp3`, 0, `bonang-bppl7.mp3`, 0, 0, `gender-gppl3.mp3`, 0, 0, 0, 0, `saron-spsl2.mp3`, `cheap_sn_fx.mp3`, `noise_hat.mp3`, `uhn_voice.mp3`, 0,] },
	{ id: 40, name: `E3`, freq: 164.81, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl5hh.mp3`, 0, `3_e.mp3`, 0, 0, 0, 0, `bonang-bpsl1hh.mp3`, 0, 0, `gender-gppl5h.mp3`, 0, 0, 0, 0, `saron-spsl3.mp3`, `chime1.mp3`, `noise_mix.mp3`, `ver_voice.mp3`, 0,] },
	{ id: 41, name: `F3`, freq: 174.61, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl5h.mp3`, `3_f.mp3`, `3_f.mp3`, 0, 0, 0, 0, `bonang-bpsl1h.mp3`, 0, 0, `gender-gppl5.mp3`, 0, 0, 0, 0, `saron-spsl5.mp3`, `chin_mute2.mp3`, `noise_perc2.mp3`, `wah_voice.mp3`, 0,] },
	{ id: 42, name: `F#3`, freq: 185, samples: [0, 0, 0, 0, 0, 0, `fS3v3.mp3`, `gambang-gsl5l.mp3`, 0, 0, 0, `Flute2_Fd3.mp3`, `Flute2_Fd3.mp3`, 0, `bonang-bpsl1.mp3`, 0, 0, `gender-gppl6h.mp3`, 0, 0, 0, 0, `saron-spsl6l.mp3`, `chin_mute.mp3`, `noise_perc.mp3`, `washbrd_hit.mp3`, 0,] },
	{ id: 43, name: `G3`, freq: 196, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl5.mp3`, 0, `3_g.mp3`, 0, 0, 0, 0, `bonang-bpsl2hh.mp3`, 0, 0, `gender-gppl6l.mp3`, 0, 0, 0, 0, `saron-spsl6.mp3`, `chin_open.mp3`, `noise_sn.mp3`, `washbrd_wipe.mp3`, 0,] },
	{ id: 44, name: `G#3`, freq: 207.65, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl6h.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bpsl2h.mp3`, 0, 0, `gender-gppl6.mp3`, 0, 0, 0, 0, 0, `ci_hhop.mp3`, `noiz_sn.mp3`, `wind_chime_2.mp3`, 0,] },
	{ id: 45, name: `A3`, freq: 220, samples: [0, 0, 0, 0, 0, 0, `a3v3.mp3`, `gambang-gsl6l.mp3`, `3_a.mp3`, `3_a.mp3`, 0, 0, `Flute2_A3.mp3`, 0, `bonang-bpsl2.mp3`, 0, 0, `gender-gppl7h.mp3`, 0, 0, 0, 0, 0, `clap_001.mp3`, `ohkawa_mu.mp3`, `windchimes_1.mp3`, 0,] },
	{ id: 46, name: `A#3`, freq: 233.08, samples: [0, 0, 0, 0, 0, 0, 0, `gambang-gsl6.mp3`, 0, 0, 0, `Flute_Ad3.mp3`, 0, 0, `bonang-bpsl3h.mp3`, 0, 0, `gender-gppl7l.mp3`, 0, 0, 0, 0, 0, `clap_ff.mp3`, `ohkawa_open.mp3`, `wood_shake.mp3`, 0,] },
	{ id: 47, name: `B3`, freq: 246.94, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gaf.mp3`, 0, `3_b.mp3`, 0, 0, 0, 0, `bonang-bpsl3.mp3`, 0, 0, `gender-gppl7.mp3`, 0, 0, 0, 0, 0, `clap_low.mp3`, `ohu_bd.mp3`, `zilkc20cp2_r.mp3`, 0,] },
	{ id: 48, name: `C4`, freq: 261.63, samples: [0, 0, 0, 0, 0, 0, `c4v3.mp3`, `gong-gap.mp3`, `4_c.mp3`, `4_c.mp3`, 0, `Flute_C4.mp3`, `Flute2_C4.mp3`, 0, `bonang-bpsl5h.mp3`, 0, 0, `gender-gpsl1hh.mp3`, 0, 0, 0, 0, 0, `claves.mp3`, `olient_bell.mp3`, `zing_1.mp3`, 0,] },
	{ id: 49, name: `C#4`, freq: 277.18, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gkpl1f.mp3`, 0, 0, 0, 0, 0, 0, `bonang-bpsl5.mp3`, 0, 0, `gender-gpsl1h.mp3`, 0, 0, 0, 0, 0, `cng_donk__1.mp3`, `orient_bell2.mp3`, `zing_2.mp3`, 0,] },
	{ id: 50, name: `D4`, freq: 293.66, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gkpl1p.mp3`, 0, `4_d.mp3`, 0, `Flute_D4.mp3`, 0, 0, `bonang-bpsl6h.mp3`, 0, 0, `gender-gpsl1.mp3`, 0, 0, 0, 0, 0, `cng_donk.mp3`, `orientbell_3.mp3`, 0, 0,] },
	{ id: 51, name: `D#4`, freq: 311.13, samples: [0, 0, 0, 0, 0, 0, `dS4v3.mp3`, `gong-gkpl2f.mp3`, `4_eb.mp3`, 0, 0, `Flute_Fd4.mp3`, 0, 0, `bonang-bpsl6.mp3`, 0, 0, `gender-gpsl2hh.mp3`, 0, 0, 0, 0, 0, `cng_hi_m.mp3`, `orient_bell4.mp3`, 0, 0,] },
	{ id: 52, name: `E4`, freq: 329.63, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gkpl2p.mp3`, 0, `4_e.mp3`, 0, 0, 0, 0, 0, 0, 0, `gender-gpsl2h.mp3`, 0, 0, 0, 0, 0, `cng_lo.mp3`, `orient_perc1.mp3`, 0, 0,] },
	{ id: 53, name: `F4`, freq: 349.23, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gkpl3f.mp3`, 0, `4_f.mp3`, 0, 0, 0, 0, 0, 0, 0, `gender-gpsl2.mp3`, 0, 0, 0, 0, 0, `cng_lo_open.mp3`, `orient_perc2.mp3`, 0, 0,] },
	{ id: 54, name: `F#4`, freq: 369.99, samples: [0, 0, 0, 0, 0, 0, `fS4v3.mp3`, `gong-gkpl3p.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gpsl3hh.mp3`, 0, 0, 0, 0, 0, `cng_mid_m.mp3`, `orient_perc3.mp3`, 0, 0,] },
	{ id: 55, name: `G4`, freq: 392, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gkpl5f.mp3`, `4_g.mp3`, `4_g.mp3`, 0, 0, 0, 0, 0, 0, 0, `gender-gpsl3h.mp3`, 0, 0, 0, 0, 0, `cng_mid.mp3`, `o_taiko_1.mp3`, 0, 0,] },
	{ id: 56, name: `G#4`, freq: 415.3, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gkpl5p.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gpsl3.mp3`, 0, 0, 0, 0, 0, `cng_mid_open.mp3`, `o_taiko1side.mp3`, 0, 0,] },
	{ id: 57, name: `A4`, freq: 440, samples: [0, 0, 0, 0, 0, 0, `a4v3.mp3`, `gong-gkpl6f.mp3`, 0, `4_a.mp3`, 0, 0, 0, 0, 0, 0, 0, `gender-gpsl5h.mp3`, 0, 0, 0, 0, 0, `comp_block.mp3`, `o_taiko2side.mp3`, 0, 0,] },
	{ id: 58, name: `A#4`, freq: 466.16, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gkpl6p.mp3`, `4_bb.mp3`, 0, 0, `Flute_Ad4.mp3`, 0, 0, 0, 0, 0, `gender-gpsl5.mp3`, 0, 0, 0, 0, 0, `cowbell_1.mp3`, `palm_stone.mp3`, 0, 0,] },
	{ id: 59, name: `B4`, freq: 493.88, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gkpl7f.mp3`, 0, `4_b.mp3`, 0, 0, 0, 0, 0, 0, 0, `gender-gpsl6h.mp3`, 0, 0, 0, 0, 0, `cowbell_h.mp3`, `pods_1.mp3`, 0, 0,] },
	{ id: 60, name: `C5`, freq: 523.25, samples: [0, 0, 0, 0, 0, 0, `c5v3.mp3`, `gong-gkpl7p.mp3`, 0, `5_c.mp3`, 0, 0, 0, 0, 0, 0, 0, `gender-gpsl6l.mp3`, 0, 0, 0, 0, 0, `crash_p.mp3`, `pop_snap.mp3`, 0, 0,] },
	{ id: 61, name: `C#5`, freq: 554.37, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gksl1f.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gpsl6.mp3`, 0, 0, 0, 0, 0, `crash_q.mp3`, `pou_sn.mp3`, 0, 0,] },
	{ id: 62, name: `D5`, freq: 587.33, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gksl1lf.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gspl1.mp3`, 0, 0, 0, 0, 0, `crash_r.mp3`, `ride_cup.mp3`, 0, 0,] },
	{ id: 63, name: `D#5`, freq: 622.25, samples: [0, 0, 0, 0, 0, 0, `dS5v3.mp3`, `gong-gksl1lp.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gspl2.mp3`, 0, 0, 0, 0, 0, `crash_s.mp3`, `ride_p.mp3`, 0, 0,] },
	{ id: 64, name: `E5`, freq: 659.25, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gksl1p.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gspl3.mp3`, 0, 0, 0, 0, 0, `crash_t.mp3`, `ride_q.mp3`, 0, 0,] },
	{ id: 65, name: `F5`, freq: 698.46, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gksl2f.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gspl4.mp3`, 0, 0, 0, 0, 0, `dance_sn.mp3`, `ride_r.mp3`, 0, 0,] },
	{ id: 66, name: `F#5`, freq: 739.99, samples: [0, 0, 0, 0, 0, 0, `fS5v3.mp3`, `gong-gksl2lf.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gspl5.mp3`, 0, 0, 0, 0, 0, `darb_dum.mp3`, `ride_s.mp3`, 0, 0,] },
	{ id: 67, name: `G5`, freq: 783.99, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gksl2lp.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gspl6.mp3`, 0, 0, 0, 0, 0, `darb_h_mu.mp3`, `rim_mix05.mp3`, 0, 0,] },
	{ id: 68, name: `G#5`, freq: 830.61, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gksl2p.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gspl7.mp3`, 0, 0, 0, 0, 0, `darb_h_open.mp3`, `rivet_fr.mp3`, 0, 0,] },
	{ id: 69, name: `A5`, freq: 880, samples: [0, 0, 0, 0, 0, 0, `a5v3.mp3`, `gong-gksl3f.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gssl1h.mp3`, 0, 0, 0, 0, 0, `dist_hit.mp3`, `scratch.mp3`, 0, 0,] },
	{ id: 70, name: `A#5`, freq: 932.33, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gksl3p.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gssl1.mp3`, 0, 0, 0, 0, 0, `dist_noiz.mp3`, `shak_1.mp3`, 0, 0,] },
	{ id: 71, name: `B5`, freq: 987.77, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gksl5f.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gssl2.mp3`, 0, 0, 0, 0, 0, `dist_sn_2.mp3`, `shime_hit.mp3`, 0, 0,] },
	{ id: 72, name: `C6`, freq: 1046.5, samples: [0, 0, 0, 0, 0, 0, `c6v3.mp3`, `gong-gksl5p.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gssl3.mp3`, 0, 0, 0, 0, 0, `dist_sn.mp3`, `shime_mu.mp3`, 0, 0,] },
	{ id: 73, name: `C#6`, freq: 1108.73, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gksl6f.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gssl5.mp3`, 0, 0, 0, 0, 0, `finger_cym1.mp3`, `shime_slap.mp3`, 0, 0,] },
	{ id: 74, name: `D6`, freq: 1174.66, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gksl6p.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gssl6l.mp3`, 0, 0, 0, 0, 0, `finger_cym2.mp3`, `short_sn.mp3`, 0, 0,] },
	{ id: 75, name: `D#6`, freq: 1244.51, samples: [0, 0, 0, 0, 0, 0, `dS6v3.mp3`, `gong-gsf.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gender-gssl6.mp3`, 0, 0, 0, 0, 0, `finger_cym3.mp3`, `slap_fx.mp3`, 0, 0,] },
	{ id: 76, name: `E6`, freq: 1318.51, samples: [0, 0, 0, 0, 0, 0, 0, `gong-gsp.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `fl_sn.mp3`, `slapstick.mp3`, 0, 0,] },
	{ id: 77, name: `F6`, freq: 1396.91, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-kpl1h.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `frtriang_l1.mp3`, `sleighbell.mp3`, 0, 0,] },
	{ id: 78, name: `F#6`, freq: 1479.98, samples: [0, 0, 0, 0, 0, 0, `fS6v3.mp3`, `kenong-kpl1hs.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `guiro.mp3`, `snap_sn.mp3`, 0, 0,] },
	{ id: 79, name: `G6`, freq: 1567.98, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-kpl2.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `guiro_slow.mp3`, `snap_sn_rev.mp3`, 0, 0,] },
	{ id: 80, name: `G#6`, freq: 1661.22, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-kpl2s.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gun_sn.mp3`, `sn_att.mp3`, 0, 0,] },
	{ id: 81, name: `A6`, freq: 1760, samples: [0, 0, 0, 0, 0, 0, `a6v3.mp3`, `kenong-kpl3.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `gun_sn_rev.mp3`, `sn_beat.mp3`, 0, 0,] },
	{ id: 82, name: `A#6`, freq: 1864.66, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-kpl3s.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `hhcl_el.mp3`, `sn_clap_mix.mp3`, 0, 0,] },
	{ id: 83, name: `B6`, freq: 1975.53, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-kpl5.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `hh_sn.mp3`, `sn_cut.mp3`, 0, 0,] },
	{ id: 84, name: `C7`, freq: 2093, samples: [0, 0, 0, 0, 0, 0, `c7v3.mp3`, `kenong-kpl5s.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `hh_stack.mp3`, `sn_fx1.mp3`, 0, 0,] },
	{ id: 85, name: `C#7`, freq: 2217.46, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-kpl6.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `hiplik.mp3`, `sn_fx2.mp3`, 0, 0,] },
	{ id: 86, name: `D7`, freq: 2349.32, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-kpl6s.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `hits.mp3`, `sn_metal_mix2.mp3`, 0, 0,] },
	{ id: 87, name: `D#7`, freq: 2489.02, samples: [0, 0, 0, 0, 0, 0, `dS7v3.mp3`, `kenong-kpl7.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `h_tom10ml2.mp3`, `sn_metal_mix.mp3`, 0, 0,] },
	{ id: 88, name: `E7`, freq: 2637.02, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-kpl7s.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `h_tom10mlt.mp3`, `sn_rezo.mp3`, 0, 0,] },
	{ id: 89, name: `F7`, freq: 2793.83, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-ksl1h.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `i_bell1.mp3`, `sn_scratch.mp3`, 0, 0,] },
	{ id: 90, name: `F#7`, freq: 2959.96, samples: [0, 0, 0, 0, 0, 0, `fS7v3.mp3`, `kenong-ksl1hs.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `i_bell2.mp3`, `spoke_hh11_l.mp3`, 0, 0,] },
	{ id: 91, name: `G7`, freq: 3135.96, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-ksl2h.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `i_bell3.mp3`, `spoke_hhc5_l.mp3`, 0, 0,] },
	{ id: 92, name: `G#7`, freq: 3322.44, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-ksl2hs.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `i_bell4.mp3`, `spoke_hhf8_l.mp3`, 0, 0,] },
	{ id: 93, name: `A7`, freq: 3520, samples: [0, 0, 0, 0, 0, 0, `a7v3.mp3`, `kenong-ksl2.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `i_bell5.mp3`, `spooky_drum.mp3`, 0, 0,] },
	{ id: 94, name: `A#7`, freq: 3729.31, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-ksl2s.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `i_bell6.mp3`, `stack_hit2.mp3`, 0, 0,] },
	{ id: 95, name: `B7`, freq: 3951.07, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-ksl3.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `i_bell7.mp3`, `stack_hit.mp3`, 0, 0,] },
	{ id: 96, name: `C8`, freq: 4186.01, samples: [0, 0, 0, 0, 0, 0, `c8v3.mp3`, `kenong-ksl3s.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `i_bell8.mp3`, `stack_sn.mp3`, 0, 0,] },
	{ id: 97, name: `C#8`, freq: 4434.92, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-ksl5.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `i_bell9.mp3`, `stack_syn_cow.mp3`, 0, 0,] },
	{ id: 98, name: `D8`, freq: 4698.63, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-ksl5s.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `ist_22siz2_l.mp3`, `stop.mp3`, 0, 0,] },
	{ id: 99, name: `D#8`, freq: 4978.03, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-ksl6.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, `ist_22tip2_r.mp3`, `str_shake.mp3`, 0, 0,] },
	{ id: 100, name: `E8`, freq: 5274.04, samples: [0, 0, 0, 0, 0, 0, 0, `kenong-ksl6s.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,] },
	{ id: 101, name: `F8`, freq: 5587.65, samples: [0, 0, 0, 0, 0, 0, 0, `kempyang-kppl6.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,] },
	{ id: 102, name: `F#8`, freq: 5919.91, samples: [0, 0, 0, 0, 0, 0, 0, `kempyang-kppl6s.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,] },
	{ id: 103, name: `G8`, freq: 6271.93, samples: [0, 0, 0, 0, 0, 0, 0, `kempyang-kpsl1.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,] },
	{ id: 104, name: `G#8`, freq: 6644.88, samples: [0, 0, 0, 0, 0, 0, 0, `kempyang-kpsl1s.mp3`, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,] },
	{ id: 105, name: `A8`, freq: 7040, samples: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,] },
	{ id: 106, name: `A#8`, freq: 7458.62, samples: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,] },
	{ id: 107, name: `B8`, freq: 7902.13, samples: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,] },
]

/**
Sequenze predefinite di note: ha dei costruttori automatizzati
Ordinale per massimo numero di utilizzi in modo da scongiurare uniformità!

TAGS:
creazione (manuale, motore -> createA etc. )
cosa può fara suonare (solo,orch,drum) corrispondenti alle categorie strumenti (solos, orchs,drums )  
tag elementari: beat (per composizioni) melody, side (accompagnamento), rare (suonato sporadicamente)

Formato di input, array dati:
	[
		[
			nota
			durata
			posizione
			volume
			pan
			portamento
		]
	]
 */
const noteSequences =
{
	//Inizializza
	init: function() {

		let rapp = this;

		this.createSingles();

		let N = 36; //number of sequences
		//		let S = N + 1; //number of notes into sequence
		//		for (let i = 0; i < N; i++) {
		//			this.createA(S - i, 4);
		//			this.createB(S - i, 4);
		//			this.createC(S - i, 1, i + 1);
		//		}
		//

		N = 100;
		for (let i = 0; i < N; i++) {
			this.createD(N, 5, N, .5);
		}

		N = 100;
		for (let i = 0; i < N; i++) {
			this.createE(Math.random() * 20 + 3, 20, 6, 0);
		}


		//aggiungiamo il nuimero di note
		this.sequences.forEach((el) => {
			if (rapp.maxnotes < el.notes.length) rapp.maxnotes = el.notes.length;
			if (rapp.minnotes > el.notes.length) rapp.minnotes = el.notes.length;
		});

		if (rTComment) console.log(`SEQUENCES Nr: ${rapp.sequences.length}, minnotes: ${rapp.minnotes}, maxnotes: ${rapp.maxnotes}`);
	},
	/**
	Creazione automatizzata 1
	ES6 notazione, crea un asequenza di note e la appende alla lista*/
	createA(numnotes = 36, maxsequences = 5) {
		let rapp = this;
		let i = 0;
		let position = 0;
		let durata = 1;
		let volume = 1;
		let pan = 0;
		let portamento = 0;

		let tot = 2 * Math.PI; //360°
		let step = tot / numnotes; // x note


		let id = rapp.sequences.length;

		let tags = "seqA";
		if (numnotes > 15) { tags += " melody solo"; }
		else if (numnotes > 8) { tags += " side orch"; }
		else if (numnotes > 3) { tags += " side drum orch"; }
		else { tags += " beat drum orch"; }


		//creiamo la sequenza da aggiungere alle precedenti
		let sequenza = {
			id: id,
			tag: tags,
			max: maxsequences,
			counter: 0,
			notes: []
		};
		let x = 0;
		for (let t = 0; t < tot; t += step) {
			//note
			let A = 0.5 + Math.sin(t) * 0.5;
			let B = 0.5 + Math.sin(t + 2 * t) * 0.5;
			let C = 0.5 + Math.sin(Math.PI * (A * B + A + B)) * 0.5;

			let N0 = Math.floor(12 * A);
			let N1 = Math.floor(12 * B);
			let N2 = Math.floor(12 * C);
			//note

			//durations
			if (x % 2 == 0) {
				durata = 2;
			} else {
				durata = 1;
			}
			//durations

			//posizioni
			//posizioni

			//volume
			//volume

			sequenza.notes.push([N2, durata, position, volume, pan, portamento]);

			position = position + durata;
			x++;
		}

		rapp.sequences.push(sequenza);

	},
	/**
	Creazione automatizzata 2
	ES6 notazione, crea un asequenza di note e la appende alla lista*/
	createB(numnotes = 36, maxsequences = 5) {
		let rapp = this;
		let i = 0;
		let position = 0;
		let durata = 1;
		let volume = 1;
		let pan = 0;
		let portamento = .1;

		let tot = 2 * Math.PI; //360°
		let step = tot / numnotes; // x note

		let tags = "seqB";
		if (numnotes > 15) { tags += " melody solo"; }
		else if (numnotes > 8) { tags += " side orch"; }
		else if (numnotes > 3) { tags += " side drum orch"; }
		else { tags += " beat drum orch"; }

		let id = rapp.sequences.length;

		//creiamo la sequenza da aggiungere alle precedenti
		let sequenza = {
			id: id,
			tag: tags,
			max: maxsequences,
			counter: 0,
			notes: []
		};

		let x = 0;

		for (let t = 0; t < tot; t += step) {
			//note
			let A = 0.5 + Math.cos(2 * t) * 0.5;
			let B = 0.5 + Math.sin(t + 2 * t) * 0.5;
			let C = 0.5 + Math.sin(Math.PI * (A + B)) * 0.5;

			let N0 = Math.floor(12 * A);
			let N1 = Math.floor(12 * B);
			let N2 = Math.floor(12 * C);
			//note

			//durations
			durata = C * 3 + 1;
			//durations

			//posizioni
			//posizioni

			//volume
			//volume
			if (x % 3 == 0) {
				sequenza.notes.push([N0, durata, position, volume, pan, portamento]);

			} else if (x % 2 == 0) {

				sequenza.notes.push([N1, durata, position, volume, pan, portamento]);

			} else {
				sequenza.notes.push([N2, durata, position, volume, pan, portamento]);
			}

			position = position + durata;
			x++;
		}

		rapp.sequences.push(sequenza);

	},
	/**
	Creazione automatizzata 2
	ES6 notazione, crea un asequenza di note e la appende alla lista*/
	createC(numnotes = 36, maxsequences = 5, faktor = 1) {
		let rapp = this;
		let i = 0;
		let position = 0;
		let durata = 2;
		let volume = 1;
		let pan = 0;
		let portamento = 0;

		let tot = 2 * Math.PI; //360°
		let step = tot / numnotes; // x note

		let tags = "seqC";
		if (numnotes > 15) { tags += " melody solo"; }
		else if (numnotes > 8) { tags += " side orch"; }
		else if (numnotes > 3) { tags += " side drum orch"; }
		else { tags += " beat drum orch"; }

		let id = rapp.sequences.length;

		//creiamo la sequenza da aggiungere alle precedenti
		let sequenza = {
			id: id,
			tag: tags,
			max: maxsequences,
			counter: 0,
			notes: []
		};

		let x = 0;
		for (let t = 0; t < tot; t += step) {
			//note
			let A = 0.5 + Math.cos(faktor * t) * 0.5;
			let B = 0.5 + Math.sin(faktor * t + 2 * t) * 0.5;
			let C = 0.5 + Math.sin(Math.PI * (A + B)) * 0.5;

			let N0 = Math.floor(12 * A);
			let N1 = Math.floor(12 * B);
			let N2 = Math.floor(12 * C);
			//note

			//durations
			//durations

			//posizioni
			//posizioni

			//volume
			//volume
			if (x % 3 == 0) {
				durata = 4;
				volume = 1;
				sequenza.notes.push([N0, durata, position, volume, pan, portamento]);

			} else if (x % 2 == 0) {
				durata = 6;
				volume = 1;
				sequenza.notes.push([N1, durata, position, volume, pan, portamento]);

			} else {
				durata = 2;
				volume = .6;
				sequenza.notes.push([N2, durata, position, volume, pan, portamento]);
			}

			position = position + durata;
			x++;
		}

		rapp.sequences.push(sequenza);

	},
	/**
	Creazione automatizzata 2
	ES6 notazione, crea un asequenza di note e la appende alla lista*/
	createD(numnotes = 36, maxsequences = 5, faktor = 1, durata = .1) {
		let rapp = this;
		let i = 0;
		let position = 0;
		let volume = 1;
		let pan = 0;
		let portamento = 0;

		let tot = 2 * Math.PI; //360°
		let step = tot / numnotes; // x note

		let tags = "seqD";
		if (numnotes > 15) { tags += " melody solo"; }
		else if (numnotes > 8) { tags += " side orch"; }
		else if (numnotes > 3) { tags += " side drum orch"; }
		else { tags += " beat drum orch"; }

		let id = rapp.sequences.length;

		//creiamo la sequenza da aggiungere alle precedenti
		let sequenza = {
			id: id,
			tag: tags,
			max: maxsequences,
			counter: 0,
			notes: []
		};

		let x = 0;
		//decremento volume dalla metà note alla fine 1->0
		let volumestep = 2 / numnotes; //step di metà delle note : 1/(N/2) = 2/N

		for (let t = 0; t < tot; t += step) {
			//note
			let A = 0.5 + Math.cos(faktor * t) * 0.5;
			let B = 0.5 + Math.sin(faktor * t + 2 * t) * 0.5;
			let C = 0.5 + Math.sin(Math.PI * (A + B)) * 0.5;

			let N0 = Math.floor(12 * A);
			let N1 = Math.floor(12 * B);
			let N2 = Math.floor(12 * C);
			//note

			//durations
			//durations

			//posizioni
			//posizioni

			//volume
			//dalla metà sequernza in poi si diminuisce il volume a zero
			if (t >= tot / 2) {
				volume -= volumestep;
			}


			//volume
			if (x % 3 == 0) {
				//				durata = 4;
				//				volume = 1;
				sequenza.notes.push([N2, durata, position, volume, pan, portamento]);

			} else if (x % 2 == 0) {
				//				durata = 6;
				//				volume = 1;
				sequenza.notes.push([N1, durata, position, volume, pan, portamento]);

			} else {
				//				durata = 2;
				//				volume = .6;
				sequenza.notes.push([N0, durata, position, volume, pan, portamento]);
			}

			position = position + durata;
			x++;
		}
		//		if (rTComment)  console.log('sequenza',sequenza, volumestep,volume);
		//		throw('mona');

		rapp.sequences.push(sequenza);

	},
	/**
	Creazione automatizzata di sequenze di note singole*/
	createSingles() {
		let rapp = this;
		let i = 0;

		let tags = "seqSingle beat drum single";
		let maxsequences = 100;
		let pan = 0;

		//creiamo le sequenza da aggiungere alle precedenti
		for (let nota = 0; nota < 12; nota++) {
			for (let durata = 1; durata < 10; durata++) {
				for (let volume = 1; volume > .2; volume -= .1) {
					for (let portamento = 0; portamento < 1; portamento += .2) {
						let sequenza = {
							id: rapp.sequences.length,
							tag: tags,
							max: maxsequences,
							counter: 0,
							//0: posizione
							notes: [[nota, durata, 0, volume, pan, portamento]]
						};
						rapp.sequences.push(sequenza);
					}
				}
			}
		}
	},

	/**prende sequenze più piccole di tot e ne combina le note in nuova sequenza
	parametro: 
	notes_threshold - numero di note per prendere in considerazione la sequenza
	numnotes - numero di note della sequenza in uscita
	randomize - randomizza le note nella sequenza
			0 - non randommizzate
			1 - randomizzate le sequenze in entrata
			2 - randomizzate le note finali
	*/
	createE(numnotes = 15, maxsequences = 5, notes_threshold = 6, randomize = 0) {

		let rapp = this;
		let rnd = [];
		//numero di random numbers
		let RN = 10;
		//random numbers 1->RN SERVE eg. PER LA DURATA MASSIMA DELLA SINGOLA NOTA
		for (let i = 0; i < RN; i++) {
			rnd.push(Math.random() * RN + 2);
		};


		//filtriamo tutte le sequenze che hanno un numero di note minore di tot.
		let seq = rapp.sequences.filter((el) => {
			return el.notes.length <= notes_threshold;
		});

		//randomizziamo le sequenze!
		if (randomize == 1) {
			for (let i = seq.length - 1; i > 0; i--) {
				let j = Math.floor(Math.random() * (i + 1));
				let temp = seq[i];
				seq[i] = seq[j];
				seq[j] = temp;
			}
		}


		//destinazione finale delle note!
		let notes = [];
		//posizione della nota nello score (andava ricalcolata!)
		let pos = 0;

		//estrae da ogni sequenza le note. nel caso siano pià lunghe del massimo durata previsto le diminuirà in durata
		let maxdurata = rnd[0]; //massima durata della nota 
		seq.every((el) => {

			let ret = true;
			//per ogni nota della sequenza
			el.notes.every((n) => {
				let dur = n[1];
				if (dur > maxdurata) dur = maxdurata;//aggiustiamo la durata della nota
				/**[nota, durata , posizione , volume, pan, portamento] */
				let nota = [n[0], dur, pos, n[3], n[4], n[5]];
				notes.push(nota);
				pos += dur;

				if (notes.length > numnotes) {
					ret = false;
					return false;
				}

			});
			return ret;
		});

		//randomizziamo le note!
		if (randomize == 2) {
			for (let i = notes.length - 1; i > 0; i--) {
				let j = Math.floor(Math.random() * (i + 1));
				let temp = notes[i];
				notes[i] = notes[j];
				notes[j] = temp;
			}
		}

		//		let numnotes = seq.length;
		let tags = "seqE";
		if (numnotes > 15) { tags += " melody solo orch"; }
		else if (numnotes > 8) { tags += " side orch"; }
		else if (numnotes > 3) { tags += " side drum orch"; }
		else { tags += " beat drum orch"; }

		let id = rapp.sequences.length;

		//creiamo la sequenza da aggiungere alle precedenti
		let sequenza = {
			id: id,
			tag: tags,
			max: maxsequences,
			counter: 0,
			notes: notes
		};

		rapp.sequences.push(sequenza);
	},

	/**
	ritorna un array di sequenze
	minnotes: numero minimo di note nella sequenza, -1
	maxnotes: numero massimo di note nella sequenza
	order:
		0: random
		1: crescente (da meno note a più note, assoluto)
		2: decrescente (da piu note a meno note, assoluto)
		3: crescente con counter minore (prima le sequenze meno utilizzate)
		4: decrescente con counter minore (prima le sequenze meno utilizzate)
	)
	*/
	getSequences(tags = "", minnotes = -1, maxnotes = -1, order = 0) {

		if (rTComment) console.log('getSequences');

		//filtriamo le sequenze che non hanno raggiunto il massimo di utilizzi
		let seqs = this.sequences.filter((el) => {
			return el.counter < el.max;
		});

		//filtriamo i tags se il filtro è presente!
		if (tags != "") {
			//array di tags
			let tg0 = tags.split(" ");

			//devono esserci tutti, se no torniamo falso
			seqs = seqs.filter((el) => {
				let tg1 = el.tag.split(" ");
				/** 
				ritorna true se tutti gli elementi di tg0 (parametro) sono nei tags
				quando true si aggiunge l'elemento alla lista filtrata'
				every + includes: https://bobbyhadz.com/blog/javascript-check-if-array-contains-all-elements-another-array*/
				return tg0.every(el2 => { return tg1.includes(el2) })

			});

		}

		//se attivo l'indicatore minnote allora filtriamo le note maggiori dell'indicatore min
		if (minnotes > 0) {
			seqs = seqs.filter((el) => {
				return el.notes.length >= minnotes;
			});
		}

		//se attivo l'indicatore maxnote allora filtriamo le note minori dell'indicatore max
		if (maxnotes > 0) {
			seqs = seqs.filter((el) => {
				return el.notes.length <= maxnotes;
			});
		}

		switch (order) {
			case 0:
				/* Randomize array in-place using Durstenfeld shuffle algorithm */
				for (var i = seqs.length - 1; i > 0; i--) {
					var j = Math.floor(Math.random() * (i + 1));
					var temp = seqs[i];
					seqs[i] = seqs[j];
					seqs[j] = temp;
				}
				break;
			case 1:
				return seqs.sort((a, b) => {
					return a.notes.length - b.notes.length;  //dal più piccolo al più grande
				});
				break;
			case 2:
				return seqs.sort((a, b) => {
					return b.notes.length - a.notes.length;  //dal più grande al più piccolo
				});
				break;
			case 3:
				return seqs.sort((a, b) => {
					//Ordiniamo per counter
					if (a.counter > b.counter) return 1;
					if (a.counter < b.counter) return -1;

					return a.notes.length - b.notes.length;  //dal più piccolo al più grande
				});
				break;
			case 4:
				return seqs.sort((a, b) => {
					//Ordiniamo per counter
					if (a.counter > b.counter) return 1;
					if (a.counter < b.counter) return -1;

					return b.notes.length - a.notes.length;  //dal più grande al più piccolo
				});
				break;
			default:
				return seqs;
		}

		return seqs;
	},
	//numero minimo di note esistenti nelle sequenze	
	minnotes: 100000,
	//numero massimo di note nelle sequenze
	maxnotes: 0,
	//sequences
	sequences: [
		{
			id: 0,
			//			cat: {}, //la categoria: numero di suoni contemporanei, riferimento 
			tag: "man beat drum orch", //manual
			max: 50,		//numero massimo di assegnazioni
			counter: 0,	//conteggio assegnazioni 
			notes: [
				/**[nota, durata (in beats), posizione (in beats), volume, pan, portamento] */
				[0, 4, 0, 1, 0, 0],
				[2, 4, 4, 1, 0, 0],
				[0, 4, 8, 1, 0, 0],
				[4, 4, 12, 1, 0, 0],
			]
		},
		{
			id: 1,
			tag: "man beat drum orch", //manual
			max: 50,		//numero massimo di assegnazioni
			counter: 0,	//conteggio assegnazioni 
			notes: [
				[0, 2, 0, 1, 0, 0],
				[2, 4, 2, 1, 0, 0],
				[2, 4, 6, 1, 0, 0],
				[1, 2, 10, 1, 0, 0]
			],
		},
		{
			id: 4,
			tag: "man beat drum", //manual
			max: 50,		//numero massimo di assegnazioni
			counter: 0,	//conteggio assegnazioni 
			notes: [
				[2, 4, 0, .8, 0, 0],
				[1, 4, 4, 1, 0, 0],
			],
		},
		{
			id: 5,
			tag: "man beat drum orch", //manual
			max: 50,		//numero massimo di assegnazioni
			counter: 0,	//conteggio assegnazioni 
			notes: [
				[3, 4, 0, 1, 0, 0],
				[1, 2, 4, 1, 0, 0],
				[1, 4, 6, .9, 0, 0],
				[1, 4, 10, .7, 0, 0],
				[1, 2, 14, .5, 0, 0],
			],
		},
		{
			id: 6,
			tag: "man beat drum orch", //manual
			max: 50,		//numero massimo di assegnazioni
			counter: 0,	//conteggio assegnazioni 
			notes: [
				/**[nota, durata (in beats), posizione (in beats), volume, pan, portamento] */
				[2, 2, 0, 1, 0, 0],
				[5, 1, 2, 1, 0, 0],
				[5, 1, 3, .9, 0, 0],
				[3, 3, 4, .7, 0, 0],
				[3, 3, 7, .5, 0, 0],
			],
		},
		{
			id: 7,
			tag: "man beat drum", //manual
			max: 50,		//numero massimo di assegnazioni
			counter: 0,	//conteggio assegnazioni 
			notes: [
				/**[nota, durata (in beats), posizione (in beats), volume, pan, portamento] */
				[2, 3, 0, 1, 0, 0],
				[2, 1, 3, 1, 0, 0],
			],
		},

	]
}

//mores dat tle inizializzator, ki ce ne ne bere arrays zgoraj!
//gamelanSampler.init();

/**Instrument pools */
/**Instrument pools */
/** mette insieme gruppi di strumenti e permette di sceglierli 

Struttura dati:

pool: {
	solos: [] //strumenti solisti
	orchs: [] //strumenti di accompagnamento (orchestra)
	drums: [] //percussioni di qualche tipo
}

*/
const instPools = {


	//tira fuori l'id dello strumento, incrementa il counter per tirare fuori tutti gli strumenti della lista uno dopo l'altro'
	selectInstrumentPosition(pool_id = 0, type = "solo") {
		let pool = this.pools[pool_id];
		let res = 0;
		let n = 0;
		switch (type) {
			case "solo":
				res = pool.solos[pool.counter[0]++];
				if (pool.counter[0] >= pool.solos.length) pool.counter[0] = 0;
				break;
			case "orch":
				res = pool.orchs[pool.counter[1]++];
				if (pool.counter[1] >= pool.orchs.length) pool.counter[1] = 0;
				break;
			case "drum":
				res = pool.drums[pool.counter[2]++];
				if (pool.counter[2] >= pool.drums.length) pool.counter[2] = 0;
				break;
			case "single": //strumenti per la nota unica!!!
				res = pool.single[pool.counter[3]++];
				if (pool.counter[3] >= pool.single.length) pool.counter[3] = 0;
				break;
		}
		return res;
	},

	/**I pool di strumenti */
	pools: [
		{
			id: 0,
			name: "piano",
			tag: "acoustic piano gong",
			counter: [0, 0, 0, 0], //per la scelta dello strumento se solo etc.
			solos: [6],
			orchs: [6],
			//			drums: [14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25]
			drums: [6],
			single: [23]
		},
		{
			id: 1,
			name: "flute",
			tag: "acoustic flute",
			counter: [0, 0, 0, 0], //per la scelta dello strumento se solo etc.
			solos: [11],
			orchs: [9],
			drums: [14],
			single: [26]
		},
		{
			id: 2,
			name: "cello",
			tag: "acoustic cello",
			counter: [0, 0, 0, 0], //per la scelta dello strumento se solo etc.
			solos: [6],
			orchs: [6, 7],
			drums: [23],
			single: [26]
		},
		{
			id: 3,
			name: "sitar",
			tag: "acoustic sitar",
			counter: [0, 0, 0, 0], //per la scelta dello strumento se solo etc.
			solos: [11],
			orchs: [11],
			drums: [14, 15, 16, 17, 18],
			single: [26]
		},
		{
			id: 4,
			name: "synth",
			tag: "electro AM FM Poly Mono Metal",
			counter: [0, 0, 0, 0], //per la scelta dello strumento se solo etc.
			solos: [1],
			orchs: [2],
			drums: [2],
			single: [26]
		},
		{
			id: 5,
			name: "piano cello",
			tag: "acoustic piano cello",
			counter: [0, 0, 0, 0], //per la scelta dello strumento se solo etc.
			solos: [4, 6],
			orchs: [4, 6, 7],
			drums: [2, 14, 15, 16, 17, 18],
			single: [26]
		},
		{
			id: 6,
			name: "piano flute",
			tag: "acoustic piano cello",
			counter: [0, 0, 0, 0], //per la scelta dello strumento se solo etc.
			solos: [4, 9, 10],
			orchs: [4, 9, 10],
			drums: [2, 14, 15, 16, 17, 18],
			single: [26]
		},
		{
			id: 7,
			name: "piano flute cello",
			tag: "acoustic piano cello",
			counter: [0, 0, 0, 0], //per la scelta dello strumento se solo etc.
			solos: [4, 6, 9, 10],
			orchs: [4, 6, 9, 10],
			drums: [2, 14, 15, 16, 17, 18],
			single: [26]
		},
		{
			id: 8,
			name: "gamelan bonang",
			tag: "acoustic gamelan bonang",
			counter: [0, 0, 0, 0], //per la scelta dello strumento se solo etc.
			solos: [14],
			orchs: [14, 17, 19, 20],
			drums: [15, 16, 17, 18, 21],
			single: [26]
		},
		{
			id: 9,
			name: "gamelan gambang",
			tag: "acoustic gamelan gambang",
			counter: [0, 0, 0, 0], //per la scelta dello strumento se solo etc.
			solos: [16],
			orchs: [14, 17, 19, 20],
			drums: [15, 16, 17, 18, 21],
			single: [26]
		},
		{
			id: 10,
			name: "gamelan saron",
			tag: "acoustic gamelan saron",
			counter: [0, 0, 0, 0], //per la scelta dello strumento se solo etc.
			solos: [22],
			orchs: [14, 17, 19, 20],
			drums: [15, 16, 17, 18, 21],
			single: [26]
		},
		{
			id: 10,
			name: "gamelan saron",
			tag: "acoustic gamelan saron",
			counter: [0, 0, 0, 0], //per la scelta dello strumento se solo etc.
			solos: [22],
			orchs: [14, 17, 19, 20],
			drums: [15, 16, 17, 18, 21],
			single: [26]
		},

	],
	/**
	tags: una lista di tags suddivisa da spazi singoli!!!
	 */
	getPoolsByTag(tag = `piano`) {
		//array di tags
		let tg0 = tag.split(' ');
		//devono esserci tutti, se no torniamo falso
		return this.seqs.filter((el) => {
			let tg1 = el.tags.split(" ");
			/** 
			ritorna true se tutti gli elementi di tg0 (parametro) sono nei tags
			quando true si aggiunge l'elemento alla lista filtrata'
			every + includes: https://bobbyhadz.com/blog/javascript-check-if-array-contains-all-elements-another-array*/
			return tg0.every(el2 => { return tg1.includes(el2) })

		});

	},
	getPoolsById(id = 0) {
		return this.pools[id];
	},
	/**remember, n range is 0->1 */
	getPoolsByNormalizedPosition(n = 0) {
		let pl = this.pools.length;
		return this.pools[Math.floor(n * pl)];
	}

	/**inizializzazione */
}

/**Instrument pools */
/**Instrument pools */

/**SIMULTANEOUS POOLS */
/**SIMULTANEOUS POOLS */
/**Gestisce il suono contemporaneo degli strumenti.
la posizione x in seno a data data[x] corrisponde al numero di suoni contemporanei possibili

funziona così:

per determinare se si può suonare o meno basta operare sul pool.canPlay().

a suono avvenuto richiamare pool.increment altrimenti pool.decrement: si fanno carico di tutte le operazioni concernenti i suoni contemporanei 

 */

const simulPool = {
	general_max: 2,
	general_counter: 0,
	data: [],
	/** 
	crea i pool suoni simultanei
	
	 */
	init() {
		if (rTComment) console.log('SIMULPOOL INIT');
		let N = 1000; //numero strumenti che possono partecipare al pool
		let rapp = this;
		for (let i = 0; i <= 1000; i++) {
			let pool = {
				id: i,
				slots: N, //numero strumenti che possono partecipare al pool
				slots_counter: 0, //struemtni che stanno suonando ora
				max: i, //quanti possono suonare contemporaneamente
				counter: 0, //il counter
				increment() {

					if (this.counter < this.max && rapp.general_counter < rapp.general_max) {
						this.counter++;
						rapp.general_counter++;

						if (rTComment) console.log(`SIMULPOOL increment ${this.situation}`);

						return true; //ok, ha incrementato
					}
					if (rTComment) console.log(`SIMULPOOL FALSEEEEE increment ${this.situation}`);
					return false; //non abbiamo incrementato
				},
				decrement() {
					if (this.counter > 0 && rapp.general_counter > 0) {
						this.counter--;
						rapp.general_counter--;

						if (rTComment) console.log(`SIMULPOOL decrement ${this.situation}`);

						return true; //ok, ha decrementato
					}
					if (rTComment) console.log(`SIMULPOOL FALSEEEEE decrement ${this.situation}`);
					return false; //non abbiamo decrementato
				},
				/**Può suonare se il counter è minore di max */
				canPlay() {
					if (rTComment) console.log(`SIMULPOOL canPlay ${this.situation}`);
					if (this.counter < this.max && rapp.general_counter < rapp.general_max) {
						return true;
					}
					return false;
				},
				/**ritorna il numero di slots a disposizione */
				get available() {
					return this.slots - this.slots_counter;
				},
				/**ritorna il numero di slots utilizzati */
				get assigned() {
					return this.slots_counter;
				},
				/**ritorna una stringa con la situazione */
				get situation() {
					return `id: ${this.id} gmax: ${rapp.general_max} gcounter: ${rapp.general_counter} || max: ${this.max} counter: ${this.counter}`;
				}
			};
			//aggiungiamo il pool
			this.data.push(pool);
		}
	},
	/**attribuisce uno slot e ritorna il pool con il numero di strumenti simmultanei che possono suonare */
	assign(contemporanei) {
		let pool = this.data[contemporanei];
		pool.slots_counter++;
		return pool;
	}
}

//Inizializziamo il simmulPool!!
simulPool.init();


/**SIMULTANEOUS POOLS */
/**SIMULTANEOUS POOLS */


/**Accordi*/
/**Accordi*/
const Accordi = [
	[0],							//0
	[0, 4, 7],						//1
	[0, 4, 6],						//2
	[0, 3, 7],						//3
	[0, 3, 6],						//4
	[0, 2, 7],						//5
	[0, 5, 7],						//6
	[0, 4, 8],						//7
	[0, 5, 8],						//8
	[0, 3, 6, 9],					//9
	[0, 4, 7, 9],					//10
	[0, 5, 7, 9],					//11
	[0, 4, 7, 9, 14],				//12
	[0, 3, 7, 9],					//13
	[0, 3, 7, 9, 14],				//14
	[0, 4, 7, 10],					//15
	[0, 5, 7, 10],					//16
	[0, 4, 8, 10],					//17
	[0, 4, 6, 10],					//18
	[0, 4, 7, 10, 15],				//19
	[0, 4, 7, 10, 13],				//20
	[0, 4, 8, 10, 15],				//21
	[0, 4, 8, 10, 13],				//22
	[0, 4, 6, 10, 13],				//23
	[0, 4, 7, 10, 17],				//24
	[0, 4, 7, 10, 21],				//25
	[0, 4, 7, 10, 18],				//26
	[0, 4, 7, 11],					//27
	[0, 4, 6, 11],					//28
	[0, 4, 8, 11],					//29
	[0, 4, 7, 11, 18],				//30
	[0, 4, 7, 11, 21],				//31
	[0, 3, 7, 10],					//32
	[0, 3, 6, 10],					//33
	[0, 3, 7, 10, 13],				//34
	[0, 3, 7, 10, 17],				//35
	[0, 3, 7, 10, 21],				//36
	[0, 3, 7, 11],					//37
	[0, 3, 7, 11, 17],				//38
	[0, 3, 7, 11, 21],				//39
	[0, 4, 7, 10, 14],				//40
	[0, 5, 7, 10, 14],				//41
	[0, 4, 7, 14],					//42
	[0, 4, 8, 10, 14],				//43
	[0, 4, 6, 10, 14],				//44
	[0, 4, 7, 10, 14, 18],			//45
	[0, 4, 7, 10, 14, 20],			//46
	[0, 4, 7, 11, 14],				//47
	[0, 5, 7, 11, 15],				//48
	[0, 4, 8, 11, 14],				//49
	[0, 4, 7, 11, 14, 18],			//50
	[0, 3, 7, 10, 14],				//51
	[0, 3, 7, 14],					//52
	[0, 3, 6, 10, 14],				//53
	[0, 3, 7, 11, 14],				//54
	[0, 4, 7, 10, 14, 17],			//55
	[0, 4, 7, 10, 13, 17],			//56
	[0, 4, 7, 11, 14, 17],			//57
	[0, 3, 7, 10, 14, 17],			//58
	[0, 3, 7, 11, 14, 17],			//59
	[0, 4, 7, 10, 14, 21],			//60
	[0, 4, 7, 10, 15, 21],			//61
	[0, 4, 7, 10, 13, 21],			//62
	[0, 4, 6, 10, 13, 21],			//63
	[0, 4, 7, 11, 14, 21],			//64
	[0, 3, 7, 10, 14, 21],			//65
	[0, 3, 7, 11, 14, 21],			//66
	[0, 2, 4, 5, 7, 9, 11],			//67
	[0, 2, 3, 5, 7, 8, 11],			//68
	[0, 2, 3, 5, 7, 9, 11],			//69
	[0, 2, 4, 6, 8, 10],			//70
	[0, 2, 3, 5, 6, 8, 9, 11],		//71
	[0, 2, 4, 7, 9],				//72
	[0, 3, 5, 7, 10],				//73
	[0, 1, 5, 7, 10],				//74
	[0, 2, 4, 5, 7, 9, 11],			//75		//maggiore
	[0, 5],							//76		//maggiore
	[0, 2, 3, 5, 7, 9, 11],			//77		//minore
	[0, 2, 4, 5, 7, 8, 9, 11],		//78
	[0, 2, 4, 5, 7, 9, 10, 11],		//79
	[0, 3, 5, 6, 7, 10],			//80
	[0, 1, 4, 5, 7, 8, 11],			//81
	[0, 1, 4, 6, 8, 10, 11],		//82
	[0, 1, 3, 5, 7, 9, 11],			//83
	[0, 1, 3, 5, 7, 8, 11],			//84
	[0, 2, 3, 6, 7, 8, 11],			//85
	[0, 2, 3, 5, 7, 9, 10],			//86
	[0, 1, 3, 5, 7, 8, 10],			//87
	[0, 2, 4, 6, 7, 9, 11],			//88
	[0, 2, 4, 5, 7, 9, 10],			//89
	[0, 2, 3, 5, 7, 8, 10],			//90
	[0, 1, 3, 5, 6, 8, 10],			//91
	[0, 2, 3, 5, 7, 8, 10],			//92
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],	//93
	[0, 1, 3, 4, 6, 7, 9, 10],		//94
	[0, 7],							//95
	[0, 1, 4, 5, 7, 8, 10],			//96
	[0, 1, 4, 5, 6, 8, 11]			//97
];

//inizailizzaimo le sequenze
noteSequences.init();


export {
	noteValues,
	noteNames,
	noteFreqs,
	noteSequences,
	Accordi,
	RSequencer,
	instPools,
	simulPool,
	rInstruments,
	rNotes,
	rBeat,
	scatterFloorTime,
	scatterCeilTime,
	beatsToTime
}